(function () {
  'use strict';

  const appRoot = document.getElementById('vp-laser-cut-file-resizer');
  if (!appRoot || appRoot.dataset.vpLcfrInitialized === 'true') return;
  appRoot.dataset.vpLcfrInitialized = 'true';
  const getById = id => appRoot.querySelector('#' + id);

  // Keep the theme editor usable if this section is removed from its preview dynamically.
  document.addEventListener('shopify:section:unload', event => {
      if (event.detail?.sectionId === appRoot.dataset.sectionId) {
          document.documentElement.classList.remove('vp-lcfr-page');
      }
  });

// ==========================================
        // Application State
        // ==========================================
        const state = {
            hasFile: false,
            filename: '',
            fileType: '',          // 'svg' or 'dxf'
            originalText: '',
            
            // Raw parsed geometry shapes in millimeters
            shapes: [],

            // Units configuration
            displayUnit: 'mm',     // 'mm' or 'in'
            
            // Original detected metrics (in millimeters)
            originalWidth: 0,
            originalHeight: 0,
            detectedThickness: 0,
            thicknessConfidence: 'Low',
            
            // User Confirmed Original Thickness (in mm)
            confirmedThickness: 0,
            targetThickness: 0,

            // Active Scaling State
            scaleX: 1.0,           // scale factor for X axis
            scaleY: 1.0,           // scale factor for Y axis
            scalePercent: 100,     // scale percentage (for locked aspect ratio display)
            lockAspect: true,

            // New User-Defined Dimensions (in mm)
            newWidth: 0,
            newHeight: 0,

            // SVG Viewport specifics (if loaded from SVG)
            originalViewBox: null,
            originalSvgWidth: 800,
            originalSvgHeight: 600,

            // DXF INSUNITS value (if loaded from DXF)
            insunits: 4,

            // Viewport Synchronized Zoom & Pan
            scale: 1.0,            // drawing canvas zoom factor
            offsetX: 0,            // drawing canvas pan offset X
            offsetY: 0,            // drawing canvas pan offset Y
            hoverWorldPos: null    // shared cursor location
        };

        const MM_PER_INCH = 25.4;

        // Thickness presets shown in the dropdown (mm value + display labels for both unit modes)
        const THICKNESS_PRESETS = [
            { mm: 3,     labelMm: '3 mm (0.118")',   labelIn: '0.118" (3 mm)' },
            { mm: 3.175, labelMm: '3.175 mm (1/8")', labelIn: '1/8" (3.175 mm)' },
            { mm: 4,     labelMm: '4 mm (0.157")',   labelIn: '0.157" (4 mm)' },
            { mm: 5,     labelMm: '5 mm (0.197")',   labelIn: '0.197" (5 mm)' },
            { mm: 6,     labelMm: '6 mm (0.236")',   labelIn: '0.236" (6 mm)' },
            { mm: 6.35,  labelMm: '6.35 mm (1/4")',  labelIn: '1/4" (6.35 mm)' }
        ];

        // UI elements pointers
        const els = {
            dropZone: getById('vp-lcfr-drop-zone'),
            fileInput: getById('vp-lcfr-file-input'),

            unitControl: getById('vp-lcfr-unit-control'),
            
            groupAnalysis: getById('vp-lcfr-group-analysis'),
            detOuterWidth: getById('vp-lcfr-det-outer-width'),
            detOuterHeight: getById('vp-lcfr-det-outer-height'),
            detThickness: getById('vp-lcfr-det-thickness'),
            detThicknessConf: getById('vp-lcfr-det-thickness-conf'),

            groupThicknessConfirm: getById('vp-lcfr-group-thickness-confirm'),
            inputOverrideThickness: getById('vp-lcfr-input-override-thickness'),
            inputTargetThickness: getById('vp-lcfr-input-target-thickness'),
            selectOverrideThickness: getById('vp-lcfr-select-override-thickness'),
            selectTargetThickness: getById('vp-lcfr-select-target-thickness'),
            unitOverrideThickness: getById('vp-lcfr-unit-override-thickness'),
            unitTargetThickness: getById('vp-lcfr-unit-target-thickness'),

            groupExport: getById('vp-lcfr-group-export'),
            btnExport: getById('vp-lcfr-btn-export'),
            btnExportLabel: getById('vp-lcfr-btn-export-label'),

            btnAbout: getById('vp-lcfr-btn-about'),
            btnCloseAbout: getById('vp-lcfr-btn-close-about'),
            aboutModal: getById('vp-lcfr-about-modal'),

            canvasOriginal: getById('vp-lcfr-canvas-original'),
            canvasScaled: getById('vp-lcfr-canvas-scaled'),

            txtFooterOriginal: getById('vp-lcfr-txt-footer-original'),
            txtFooterScaled: getById('vp-lcfr-txt-footer-scaled'),
            headerThicknessOriginal: getById('vp-lcfr-header-thickness-original'),
            headerThicknessScaled: getById('vp-lcfr-header-thickness-scaled'),
            badgeScaledPct: getById('vp-lcfr-badge-scaled-pct')
        };

        // ==========================================
        // Mathematics & Helper Utilities
        // ==========================================
        function dist(p1, p2) {
            return Math.sqrt((p1.x - p2.x)**2 + (p1.y - p2.y)**2);
        }

        // ==========================================
        // Arc Parameterization Conversion (SVG Spec)
        // ==========================================
        function svgArcToCenter(x1, y1, rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x2, y2) {
            const phi = (xAxisRotation * Math.PI) / 180;
            rx = Math.abs(rx);
            ry = Math.abs(ry);

            if (rx === 0 || ry === 0) return null;

            const cosPhi = Math.cos(phi);
            const sinPhi = Math.sin(phi);

            const dx2 = (x1 - x2) / 2;
            const dy2 = (y1 - y2) / 2;
            const x1p = cosPhi * dx2 + sinPhi * dy2;
            const y1p = -sinPhi * dx2 + cosPhi * dy2;

            let rxSq = rx * rx;
            let rySq = ry * ry;
            const x1pSq = x1p * x1p;
            const y1pSq = y1p * y1p;

            const radiiCheck = x1pSq / rxSq + y1pSq / rySq;
            if (radiiCheck > 1) {
                rx *= Math.sqrt(radiiCheck);
                ry *= Math.sqrt(radiiCheck);
                rxSq = rx * rx;
                rySq = ry * ry;
            }

            const sign = largeArcFlag === sweepFlag ? -1 : 1;
            let sq = (rxSq * rySq - rxSq * y1pSq - rySq * x1pSq) / (rxSq * y1pSq + rySq * x1pSq);
            sq = sq < 0 ? 0 : sq;
            const coef = sign * Math.sqrt(sq);
            const cxp = coef * ((rx * y1p) / ry);
            const cyp = coef * -((ry * x1p) / rx);

            const sx2 = (x1 + x2) / 2;
            const sy2 = (y1 + y2) / 2;
            const cx = cosPhi * cxp - sinPhi * cyp + sx2;
            const cy = sinPhi * cxp + cosPhi * cyp + sy2;

            const ux = (x1p - cxp) / rx;
            const uy = (y1p - cyp) / ry;
            const vx = (-x1p - cxp) / rx;
            const vy = (-y1p - cyp) / ry;

            function vecAngle(ux, uy, vx, vy) {
                const dot = ux * vx + uy * vy;
                const len = Math.sqrt(ux * ux + uy * uy) * Math.sqrt(vx * vx + vy * vy);
                let ang = Math.acos(Math.max(-1, Math.min(1, dot / len)));
                if (ux * vy - uy * vx < 0) ang = -ang;
                return ang;
            }

            const startAngle = vecAngle(1, 0, ux, uy);
            let deltaAngle = vecAngle(ux, uy, vx, vy);

            if (sweepFlag === 0 && deltaAngle > 0) {
                deltaAngle -= 2 * Math.PI;
            } else if (sweepFlag === 1 && deltaAngle < 0) {
                deltaAngle += 2 * Math.PI;
            }

            return {
                cx, cy, rx, ry,
                startAngle,
                endAngle: startAngle + deltaAngle,
                xAxisRotation,
                anticlockwise: sweepFlag === 0
            };
        }

        // Recursively subdivides a cubic bezier until each segment is flat enough (within
        // tolerance of a straight line), rather than using a fixed sample count. A fixed count
        // (e.g. always 10 samples) can miss a curve's true extreme point if the peak falls between
        // two samples, silently understating the bounding box for sharply-curved artwork — this is
        // what caused the SVG and DXF versions of the same drawing to report slightly different
        // sizes (DXF's NURBS sampling happened to land closer to the true peak by chance).
        function flattenCubicBezier(x0, y0, x1, y1, x2, y2, x3, y3, tolerance = 0.001, depth = 0) {
            // Flatness test: distance of the two control points from the chord (p0->p3).
            const dx = x3 - x0, dy = y3 - y0;
            const d1 = Math.abs((x1 - x3) * dy - (y1 - y3) * dx);
            const d2 = Math.abs((x2 - x3) * dy - (y2 - y3) * dx);
            const chordLenSq = dx * dx + dy * dy;

            if (depth >= 16 || ((d1 + d2) * (d1 + d2) < tolerance * chordLenSq)) {
                return [{ x: x3, y: y3 }];
            }

            // De Casteljau subdivision at t=0.5
            const x01 = (x0 + x1) / 2, y01 = (y0 + y1) / 2;
            const x12 = (x1 + x2) / 2, y12 = (y1 + y2) / 2;
            const x23 = (x2 + x3) / 2, y23 = (y2 + y3) / 2;
            const x012 = (x01 + x12) / 2, y012 = (y01 + y12) / 2;
            const x123 = (x12 + x23) / 2, y123 = (y12 + y23) / 2;
            const x0123 = (x012 + x123) / 2, y0123 = (y012 + y123) / 2;

            const left = flattenCubicBezier(x0, y0, x01, y01, x012, y012, x0123, y0123, tolerance, depth + 1);
            const right = flattenCubicBezier(x0123, y0123, x123, y123, x23, y23, x3, y3, tolerance, depth + 1);
            return left.concat(right);
        }

        function flattenQuadraticBezier(x0, y0, x1, y1, x2, y2, tolerance = 0.001, depth = 0) {
            const dx = x2 - x0, dy = y2 - y0;
            const d = Math.abs((x1 - x2) * dy - (y1 - y2) * dx);
            const chordLenSq = dx * dx + dy * dy;

            if (depth >= 16 || (d * d < tolerance * chordLenSq)) {
                return [{ x: x2, y: y2 }];
            }

            const x01 = (x0 + x1) / 2, y01 = (y0 + y1) / 2;
            const x12 = (x1 + x2) / 2, y12 = (y1 + y2) / 2;
            const x012 = (x01 + x12) / 2, y012 = (y01 + y12) / 2;

            const left = flattenQuadraticBezier(x0, y0, x01, y01, x012, y012, tolerance, depth + 1);
            const right = flattenQuadraticBezier(x012, y012, x12, y12, x2, y2, tolerance, depth + 1);
            return left.concat(right);
        }

        function evaluateBulgePoints(x1, y1, x2, y2, bulge, numSegments = 10) {
            const pts = [];
            const b = bulge;
            const dx = x2 - x1;
            const dy = y2 - y1;
            const L = Math.sqrt(dx * dx + dy * dy);
            if (L < 0.0001 || Math.abs(b) < 0.001) {
                return [{ x: x2, y: y2 }];
            }

            const r = L * (1 + b * b) / (4 * Math.abs(b));
            const s = b * L / 2;
            const h = r - Math.abs(s);

            const mx = (x1 + x2) / 2;
            const my = (y1 + y2) / 2;

            const nx = -dy / L;
            const ny = dx / L;

            const dir = b > 0 ? 1 : -1;
            const signOfH = (Math.abs(b) <= 1.0) ? 1 : -1;
            const cx = mx - dir * signOfH * h * nx;
            const cy = my - dir * signOfH * h * ny;

            const startAngle = Math.atan2(y1 - cy, x1 - cx);
            const sweep = 4 * Math.atan(b);

            for (let k = 1; k <= numSegments; k++) {
                const t = k / numSegments;
                const a = startAngle + sweep * t;
                pts.push({ x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) });
            }
            return pts;
        }

        // Evaluates a (possibly rational) B-spline curve at parameter t using the de Boor
        // algorithm. controlPoints: [{x,y,w?}], knots: sorted knot vector, degree: curve degree.
        function deBoorEvaluate(t, degree, controlPoints, knots) {
            const n = controlPoints.length - 1;
            // Clamp t into the valid domain to avoid edge-case out-of-range spans
            const domainMin = knots[degree];
            const domainMax = knots[knots.length - 1 - degree];
            t = Math.max(domainMin, Math.min(domainMax, t));

            // Find knot span
            let span = degree;
            for (let i = degree; i <= n; i++) {
                if (t >= knots[i] && t < knots[i + 1]) { span = i; break; }
                if (i === n) span = n; // t == domainMax edge case
            }

            const useWeights = controlPoints.some(p => p.w !== undefined && p.w !== 1);
            // Working set of homogeneous points (wx, wy, w) for rational curves, or plain (x,y,1)
            const d = [];
            for (let j = 0; j <= degree; j++) {
                const p = controlPoints[span - degree + j];
                const w = useWeights ? (p.w !== undefined ? p.w : 1) : 1;
                d.push({ x: p.x * w, y: p.y * w, w });
            }

            for (let r = 1; r <= degree; r++) {
                for (let j = degree; j >= r; j--) {
                    const i = span - degree + j;
                    const denom = (knots[i + degree - r + 1] - knots[i]);
                    const alpha = denom !== 0 ? (t - knots[i]) / denom : 0;
                    d[j] = {
                        x: (1 - alpha) * d[j - 1].x + alpha * d[j].x,
                        y: (1 - alpha) * d[j - 1].y + alpha * d[j].y,
                        w: (1 - alpha) * d[j - 1].w + alpha * d[j].w
                    };
                }
            }

            const result = d[degree];
            return useWeights && result.w !== 0
                ? { x: result.x / result.w, y: result.y / result.w }
                : { x: result.x, y: result.y };
        }

        // Flattens a full SPLINE entity (control points + knot vector + degree) into a polyline
        // point list for display, sizing heuristics, and export. Uses adaptive recursive
        // subdivision (by flatness, like the SVG bezier flattener) rather than a sample count
        // proportional to the control point count — a spline with hundreds of control points no
        // longer produces thousands of redundant points along its straight/gentle sections, while
        // sharp bends still get subdivided finely enough to find the curve's true extremes.
        function flattenSpline(controlPoints, knots, degree, tolerance = 0.005) {
            if (controlPoints.length < 2) return controlPoints.map(p => ({ x: p.x, y: p.y }));
            if (!knots || knots.length < controlPoints.length + degree + 1) {
                // Malformed/missing knot vector — fall back to drawing the control polygon
                // directly rather than failing to render the shape at all.
                return controlPoints.map(p => ({ x: p.x, y: p.y }));
            }

            const domainMin = knots[degree];
            const domainMax = knots[knots.length - 1 - degree];

            function evalAt(t) { return deBoorEvaluate(t, degree, controlPoints, knots); }

            // Recursively subdivide [tA, tB] until the midpoint is close enough to the chord
            // between its endpoints (flatness test), same principle as the bezier flattener.
            function subdivide(tA, pA, tB, pB, depth) {
                if (depth >= 20) return [pB];
                const tMid = (tA + tB) / 2;
                const pMid = evalAt(tMid);

                const dx = pB.x - pA.x, dy = pB.y - pA.y;
                const chordLenSq = dx * dx + dy * dy;
                // Perpendicular distance (squared, scaled by chord length) of the midpoint from
                // the straight line pA->pB.
                const cross = (pMid.x - pA.x) * dy - (pMid.y - pA.y) * dx;
                const distSq = chordLenSq > 1e-12 ? (cross * cross) / chordLenSq : (pMid.x-pA.x)**2 + (pMid.y-pA.y)**2;

                if (distSq < tolerance * tolerance) {
                    return [pB];
                }
                const left = subdivide(tA, pA, tMid, pMid, depth + 1);
                const right = subdivide(tMid, pMid, tB, pB, depth + 1);
                return left.concat(right);
            }

            // Start with a coarse set of anchor points at each knot span boundary (guarantees we
            // don't miss a span entirely), then adaptively refine within each span.
            const spanBoundaries = [domainMin];
            for (let i = degree; i < knots.length - degree - 1; i++) {
                if (knots[i] > spanBoundaries[spanBoundaries.length - 1] && knots[i] < domainMax) {
                    spanBoundaries.push(knots[i]);
                }
            }
            spanBoundaries.push(domainMax);

            const pts = [evalAt(spanBoundaries[0])];
            for (let i = 0; i < spanBoundaries.length - 1; i++) {
                const tA = spanBoundaries[i], tB = spanBoundaries[i + 1];
                const pA = pts[pts.length - 1];
                const pB = evalAt(tB);
                pts.push(...subdivide(tA, pA, tB, pB, 0));
            }
            return pts;
        }

        // ==========================================
        // DXF Geometry Parser
        // ==========================================
        // Exact AutoCAD Color Index (ACI) palette, indices 0-255, sourced from the netDxf
        // library's documented IndexRgb table (MIT licensed) — the same reference table used
        // by AutoCAD-compatible DXF readers/writers. Index 0 is unused/reserved. Shared at module
        // scope so both the DXF import color resolver and the export color resolver use it.
        const ACI_TABLE = ['#000000','#FF0000','#FFFF00','#00FF00','#00FFFF','#0000FF','#FF00FF','#FFFFFF','#808080','#C0C0C0','#FF0000','#FF7F7F','#A50000','#A55252','#7F0000','#7F3F3F','#4C0000','#4C2626','#260000','#261313','#FF3F00','#FF9F7F','#A52900','#A56752','#7F1F00','#7F4F3F','#4C1300','#4C2F26','#260900','#261713','#FF7F00','#FFBF7F','#A55200','#A57C52','#7F3F00','#7F5F3F','#4C2600','#4C3926','#261300','#261C13','#FFBF00','#FFDF7F','#A57C00','#A59152','#7F5F00','#7F6F3F','#4C3900','#4C4226','#261C00','#262113','#FFFF00','#FFFF7F','#A5A500','#A5A552','#7F7F00','#7F7F3F','#4C4C00','#4C4C26','#262600','#262613','#BFFF00','#DFFF7F','#7CA500','#91A552','#5F7F00','#6F7F3F','#394C00','#424C26','#1C2600','#212613','#7FFF00','#BFFF7F','#52A500','#7CA552','#3F7F00','#5F7F3F','#264C00','#394C26','#132600','#1C2613','#3FFF00','#9FFF7F','#29A500','#67A552','#1F7F00','#4F7F3F','#134C00','#2F4C26','#092600','#172613','#00FF00','#7FFF7F','#00A500','#52A552','#007F00','#3F7F3F','#004C00','#264C26','#002600','#132613','#00FF3F','#7FFF9F','#00A529','#52A567','#007F1F','#3F7F4F','#004C13','#264C2F','#002609','#135817','#00FF7F','#7FFFBF','#00A552','#52A57C','#007F3F','#3F7F5F','#004C26','#264C39','#002613','#13581C','#00FFBF','#7FFFDF','#00A57C','#52A591','#007F5F','#3F7F6F','#004C39','#264C42','#00261C','#135858','#00FFFF','#7FFFFF','#00A5A5','#52A5A5','#007F7F','#3F7F7F','#004C4C','#264C4C','#002626','#135858','#00BFFF','#7FDFFF','#007CA5','#5291A5','#005F7F','#3F6F7F','#00394C','#26427E','#001C26','#135858','#007FFF','#7FBFFF','#0052A5','#527CA5','#003F7F','#3F5F7F','#00264C','#26397E','#001326','#131C58','#003FFF','#7F9FFF','#0029A5','#5267A5','#001F7F','#3F4F7F','#00134C','#262F7E','#000926','#131758','#0000FF','#7F7FFF','#0000A5','#5252A5','#00007F','#3F3F7F','#00004C','#26267E','#000026','#131358','#3F00FF','#9F7FFF','#2900A5','#6752A5','#1F007F','#4F3F7F','#13004C','#2F267E','#090026','#171358','#7F00FF','#BF7FFF','#5200A5','#7C52A5','#3F007F','#5F3F7F','#26004C','#39267E','#130026','#1C1358','#BF00FF','#DF7FFF','#7C00A5','#9152A5','#5F007F','#6F3F7F','#39004C','#42264C','#1C0026','#581358','#FF00FF','#FF7FFF','#A500A5','#A552A5','#7F007F','#7F3F7F','#4C004C','#4C264C','#260026','#581358','#FF00BF','#FF7FDF','#A5007C','#A55291','#7F005F','#7F3F6F','#4C0039','#4C2642','#26001C','#581358','#FF007F','#FF7FBF','#A50052','#A5527C','#7F003F','#7F3F5F','#4C0026','#4C2639','#260013','#58131C','#FF003F','#FF7F9F','#A50029','#A55267','#7F001F','#7F3F4F','#4C0013','#4C262F','#260009','#581317','#000000','#656565','#666666','#999999','#CCCCCC','#FFFFFF'];

        function parseDXF(dxfText) {
            let fileScaleFactor = 1.0; 
            let insunits = 4; 
            state.hasApproximateDxfColors = false;
            
            const insUnitsIdx = dxfText.indexOf('$INSUNITS');
            if (insUnitsIdx !== -1) {
                const sub = dxfText.substring(insUnitsIdx, insUnitsIdx + 150);
                const lines = sub.split(/\r?\n/).map(l => l.trim());
                const idx70 = lines.indexOf('70');
                if (idx70 !== -1 && idx70 < lines.length - 1) {
                    insunits = parseInt(lines[idx70 + 1], 10);
                    if (insunits === 1) { 
                        fileScaleFactor = MM_PER_INCH;
                    } else if (insunits === 5) { 
                        fileScaleFactor = 10.0;
                    }
                }
            }
            state.insunits = insunits;

            const lines = dxfText.split(/\r?\n/).map(line => line.trim());
            const entities = [];
            let i = 0;

            function next() {
                if (i >= lines.length - 1) return null;
                const code = parseInt(lines[i], 10);
                const value = lines[i + 1];
                i += 2;
                return { code, value };
            }

            let currentEntity = null;      // LINE / LWPOLYLINE / POLYLINE / CIRCLE / ARC being filled
            let currentPolyline = null;    // the POLYLINE entity currently receiving VERTEX records (kept separate so VERTEX handling can't clobber it)
            let currentVertex = null;      // the VERTEX record currently being read
            let inEntitiesSection = false;
            let inBlocksSection = false;
            let currentBlockName = null;   // name of the BLOCK definition currently being read, if any
            const blocks = {};             // blockName -> array of raw entities defined inside it

            // Pushes a finished entity into the right place: the current block's entity list if
            // we're inside a BLOCK definition, otherwise the top-level entities array.
            function pushEntity(ent) {
                if (currentBlockName) {
                    (blocks[currentBlockName] || (blocks[currentBlockName] = [])).push(ent);
                } else {
                    entities.push(ent);
                }
            }

            while (i < lines.length - 1) {
                const item = next();
                if (!item) break;
                const { code, value } = item;
                const val = parseFloat(value);

                if (code === 0) {
                    if (value === 'SECTION') {
                        // entered section
                    } else if (value === 'ENDSEC') {
                        inEntitiesSection = false;
                        inBlocksSection = false;
                    } else if (value === 'BLOCK') {
                        // Entering a block definition — its name arrives via the next code-2
                        // record. Flush any in-progress entity first.
                        if (currentEntity) { pushEntity(currentEntity); currentEntity = null; }
                        currentBlockName = '__pending__';
                        continue;
                    } else if (value === 'ENDBLK') {
                        if (currentEntity) { pushEntity(currentEntity); currentEntity = null; }
                        currentBlockName = null;
                        continue;
                    }

                    // A VERTEX record belonging to the current POLYLINE
                    if (value === 'VERTEX' && currentPolyline) {
                        if (currentVertex) {
                            currentPolyline.points.push({ x: currentVertex.x, y: currentVertex.y, bulge: currentVertex.bulge || 0 });
                        }
                        currentVertex = { x: 0, y: 0, bulge: 0 };
                        continue;
                    }

                    // End of the current POLYLINE's vertex list
                    if (value === 'SEQEND' && currentPolyline) {
                        if (currentVertex) {
                            currentPolyline.points.push({ x: currentVertex.x, y: currentVertex.y, bulge: currentVertex.bulge || 0 });
                        }
                        currentVertex = null;
                        pushEntity(currentPolyline);
                        currentPolyline = null;
                        continue;
                    }

                    // Otherwise this code-0 marks a new top-level entity
                    if (inEntitiesSection || inBlocksSection || currentEntity) {
                        if (currentEntity) {
                            pushEntity(currentEntity);
                            currentEntity = null;
                        }
                        if (['LINE', 'LWPOLYLINE', 'CIRCLE', 'ARC', 'SPLINE', 'ELLIPSE', 'POINT', 'INSERT'].includes(value)) {
                            currentEntity = { type: value, points: [], properties: {} };
                        } else if (value === 'POLYLINE') {
                            currentEntity = null;
                            currentPolyline = { type: 'POLYLINE', points: [], properties: {} };
                        }
                    }
                } else if (code === 2) {
                    if (value === 'ENTITIES') {
                        inEntitiesSection = true;
                    } else if (value === 'BLOCKS') {
                        inBlocksSection = true;
                    } else if (currentBlockName === '__pending__') {
                        // This is the block-name record right after "0 BLOCK"
                        currentBlockName = value;
                        blocks[value] = blocks[value] || [];
                    }
                } else if (currentVertex) {
                    if (code === 10) currentVertex.x = val;
                    if (code === 20) currentVertex.y = val;
                    if (code === 42) currentVertex.bulge = val;
                } else if (currentPolyline) {
                    if (code === 70) currentPolyline.properties.closed = (parseInt(value, 10) & 1) !== 0;
                    if (code === 62) currentPolyline.properties.colorIndex = parseInt(value, 10);
                    if (code === 420) currentPolyline.properties.trueColor = parseInt(value, 10);
                } else if (currentEntity) {
                    if (code === 62) currentEntity.properties.colorIndex = parseInt(value, 10);
                    if (code === 420) currentEntity.properties.trueColor = parseInt(value, 10);
                    if (currentEntity.type === 'LINE') {
                        if (code === 10) currentEntity.properties.x1 = val;
                        if (code === 20) currentEntity.properties.y1 = val;
                        if (code === 11) currentEntity.properties.x2 = val;
                        if (code === 21) currentEntity.properties.y2 = val;
                    } else if (currentEntity.type === 'LWPOLYLINE') {
                        if (code === 70) currentEntity.properties.closed = (parseInt(value, 10) & 1) !== 0;
                        if (code === 10) {
                            currentEntity.points.push({ x: val, y: 0, bulge: 0 });
                        } else if (code === 20) {
                            if (currentEntity.points.length > 0) {
                                currentEntity.points[currentEntity.points.length - 1].y = val;
                            }
                        } else if (code === 42) {
                            if (currentEntity.points.length > 0) {
                                currentEntity.points[currentEntity.points.length - 1].bulge = val;
                            }
                        }
                    } else if (currentEntity.type === 'CIRCLE') {
                        if (code === 10) currentEntity.properties.cx = val;
                        if (code === 20) currentEntity.properties.cy = val;
                        if (code === 40) currentEntity.properties.r = val;
                    } else if (currentEntity.type === 'ARC') {
                        if (code === 10) currentEntity.properties.cx = val;
                        if (code === 20) currentEntity.properties.cy = val;
                        if (code === 40) currentEntity.properties.r = val;
                        if (code === 50) currentEntity.properties.startAngle = val;
                        if (code === 51) currentEntity.properties.endAngle = val;
                    } else if (currentEntity.type === 'SPLINE') {
                        if (code === 70) currentEntity.properties.flags = parseInt(value, 10);
                        if (code === 71) currentEntity.properties.degree = parseInt(value, 10);
                        // Code 40 (knot value) repeats independently of the 10/20 control-point
                        // pairs, so it's accumulated into its own array rather than into .points.
                        if (code === 40) {
                            (currentEntity.properties.knots || (currentEntity.properties.knots = [])).push(val);
                        }
                        if (code === 10) {
                            currentEntity.points.push({ x: val, y: 0 });
                        } else if (code === 20) {
                            if (currentEntity.points.length > 0) {
                                currentEntity.points[currentEntity.points.length - 1].y = val;
                            }
                        } else if (code === 41) {
                            // Weight for the most recently added control point (rational spline)
                            if (currentEntity.points.length > 0) {
                                currentEntity.points[currentEntity.points.length - 1].w = val;
                            }
                        }
                    } else if (currentEntity.type === 'ELLIPSE') {
                        // DXF ellipse: center (10/20), endpoint of major axis relative to center
                        // (11/21), ratio of minor to major axis (40), start/end parameter in
                        // radians (41/42, full ellipse when 0 to 2*PI).
                        if (code === 10) currentEntity.properties.cx = val;
                        if (code === 20) currentEntity.properties.cy = val;
                        if (code === 11) currentEntity.properties.majorX = val;
                        if (code === 21) currentEntity.properties.majorY = val;
                        if (code === 40) currentEntity.properties.ratio = val;
                        if (code === 41) currentEntity.properties.startParam = val;
                        if (code === 42) currentEntity.properties.endParam = val;
                    } else if (currentEntity.type === 'POINT') {
                        if (code === 10) currentEntity.properties.x = val;
                        if (code === 20) currentEntity.properties.y = val;
                    } else if (currentEntity.type === 'INSERT') {
                        // Block reference: block name (2), insertion point (10/20), X/Y scale
                        // factors (41/42, default 1), rotation in degrees (50, default 0).
                        if (code === 2) currentEntity.properties.blockName = value;
                        if (code === 10) currentEntity.properties.x = val;
                        if (code === 20) currentEntity.properties.y = val;
                        if (code === 41) currentEntity.properties.scaleX = val;
                        if (code === 42) currentEntity.properties.scaleY = val;
                        if (code === 50) currentEntity.properties.rotation = val;
                    }
                }
            }

            if (currentEntity) {
                pushEntity(currentEntity);
            }
            if (currentPolyline) {
                if (currentVertex) {
                    currentPolyline.points.push({ x: currentVertex.x, y: currentVertex.y, bulge: currentVertex.bulge || 0 });
                }
                pushEntity(currentPolyline);
            }

            // ACI_TABLE is defined at module scope above (shared with the export color resolver)
            function resolveDxfColor(colorIndex, trueColorInt) {
                // Group code 420 (true color) gives an exact RGB value when present — prefer it
                // over the ACI palette, which is a fixed 255-entry approximation and can be
                // noticeably off for files (e.g. CorelDRAW exports) that use a custom ACI mapping.
                if (trueColorInt !== undefined && trueColorInt !== null && !isNaN(trueColorInt)) {
                    const v = trueColorInt >>> 0; // treat as unsigned 24-bit RGB
                    const r = (v >> 16) & 0xFF;
                    const g = (v >> 8) & 0xFF;
                    const b = v & 0xFF;
                    return `#${r.toString(16).padStart(2,'0')}${g.toString(16).padStart(2,'0')}${b.toString(16).padStart(2,'0')}`.toUpperCase().replace('#', '#');
                }
                if (colorIndex === undefined || colorIndex === null) return '#1e293b';
                if (colorIndex === 256 || colorIndex === 0 || colorIndex < 0 || colorIndex > 255) {
                    // 256 = BYLAYER, 0 = BYBLOCK — we don't track per-layer colors separately,
                    // so fall back to the default shape color rather than guessing.
                    return '#1e293b';
                }
                // Indices 10-255 (the "extended" part of the ACI palette) are the ones most often
                // silently redefined by CAD/illustration tools (CorelDRAW included) without saving
                // that redefinition anywhere retrievable in the DXF file — the DXF spec has no
                // structure for it pre-CTB/STB. This is a documented limitation (see e.g. ezdxf's
                // own docs: "you can not know what color... was used intentionally" without a CTB/
                // STB file), not something guessable from the file's bytes. Flag it so the UI can
                // tell the user their DXF viewer may show a different color than expected here.
                if (colorIndex >= 10 && colorIndex <= 255) {
                    state.hasApproximateDxfColors = true;
                }
                return ACI_TABLE[colorIndex] || '#1e293b';
            }

            const shapes = entities.map((ent, idx) => {
                let shape = {
                    id: `shape_${idx}`,
                    name: `${ent.type} #${idx + 1}`,
                    originalType: ent.type,
                    color: resolveDxfColor(ent.properties.colorIndex, ent.properties.trueColor),
                    aciColorIndex: (ent.properties.trueColor === undefined || ent.properties.trueColor === null) ? ent.properties.colorIndex : null,
                    isClosed: false,
                    points: []
                };

                if (ent.type === 'LINE') {
                    shape.type = 'polyline';
                    shape.points = [
                        { id: `p_${idx}_0`, x: (ent.properties.x1 || 0) * fileScaleFactor, y: (ent.properties.y1 || 0) * fileScaleFactor, type: 'anchor' },
                        { id: `p_${idx}_1`, x: (ent.properties.x2 || 0) * fileScaleFactor, y: (ent.properties.y2 || 0) * fileScaleFactor, type: 'anchor' }
                    ];
                    shape.isClosed = false;
                } else if (ent.type === 'LWPOLYLINE' || ent.type === 'POLYLINE') {
                    shape.type = 'polyline';
                    shape.points = ent.points.map((pt, pIdx) => ({
                        id: `p_${idx}_${pIdx}`,
                        x: pt.x * fileScaleFactor,
                        y: pt.y * fileScaleFactor,
                        type: 'anchor',
                        bulge: pt.bulge || 0
                    }));
                    shape.isClosed = !!ent.properties.closed;
                } else if (ent.type === 'CIRCLE') {
                    shape.type = 'circle';
                    shape.cx = (ent.properties.cx || 0) * fileScaleFactor;
                    shape.cy = (ent.properties.cy || 0) * fileScaleFactor;
                    shape.r = (ent.properties.r || 10) * fileScaleFactor;
                    shape.isClosed = true;
                    shape.points = [
                        { id: `p_${idx}_c`, x: shape.cx, y: shape.cy, type: 'center', prop: 'center' },
                        { id: `p_${idx}_r`, x: shape.cx + shape.r, y: shape.cy, type: 'radius', prop: 'radius' }
                    ];
                } else if (ent.type === 'ARC') {
                    shape.type = 'arc';
                    shape.cx = (ent.properties.cx || 0) * fileScaleFactor;
                    shape.cy = (ent.properties.cy || 0) * fileScaleFactor;
                    shape.r = (ent.properties.r || 10) * fileScaleFactor;
                    shape.startAngle = ent.properties.startAngle || 0;
                    shape.endAngle = ent.properties.endAngle || 0;
                    shape.isClosed = false;
                    const saRad = (shape.startAngle * Math.PI) / 180;
                    const eaRad = (shape.endAngle * Math.PI) / 180;
                    shape.points = [
                        { id: `p_${idx}_c`, x: shape.cx, y: shape.cy, type: 'center', prop: 'center' },
                        { id: `p_${idx}_s`, x: shape.cx + shape.r * Math.cos(saRad), y: shape.cy + shape.r * Math.sin(saRad), type: 'arc_start', prop: 'start' },
                        { id: `p_${idx}_e`, x: shape.cx + shape.r * Math.cos(eaRad), y: shape.cy + shape.r * Math.sin(eaRad), type: 'arc_end', prop: 'end' }
                    ];
                } else if (ent.type === 'SPLINE') {
                    shape.type = 'polyline';
                    const degree = ent.properties.degree !== undefined ? ent.properties.degree : 3;
                    const knots = ent.properties.knots || [];
                    // Closed flag: DXF group 70 bit 1 (value 1) marks a closed spline
                    shape.isClosed = !!(ent.properties.flags & 1);
                    const flatPts = flattenSpline(ent.points, knots, degree);
                    shape.points = flatPts.map((pt, pIdx) => ({
                        id: `p_${idx}_${pIdx}`,
                        x: pt.x * fileScaleFactor,
                        y: pt.y * fileScaleFactor,
                        type: 'anchor'
                    }));
                }
                return shape;
            }).filter(s => s.type);

            // DXF uses a CAD/math coordinate convention (+Y points up), while the canvas/screen
            // convention used for rendering (and SVG import, which needs no correction) has +Y
            // pointing down. Without flipping here, every DXF drawing renders vertically mirrored
            // relative to how it looks in a real CAD viewer. Flip every point's Y, plus arc angles
            // (mirroring Y also mirrors the direction an arc sweeps).
            shapes.forEach(shape => {
                shape.points.forEach(pt => { pt.y = -pt.y; });
                if (shape.cy !== undefined) shape.cy = -shape.cy;
                if (shape.type === 'arc') {
                    shape.startAngle = -shape.startAngle;
                    shape.endAngle = -shape.endAngle;
                }
            });

            return shapes;
        }

        // ==========================================
        // SVG Geometry Parser
        // ==========================================
        function parseSVGPathString(d) {
            const commands = [];
            const commandRegex = /([MmLlHhVvCcSsQqTtAaZz])([^MmLlHhVvCcSsQqTtAaZz]*)/g;
            let match;
            while ((match = commandRegex.exec(d)) !== null) {
                const type = match[1];
                const argsStr = match[2];
                const args = [];
                const numRegex = /-?\d*\.?\d+(?:[eE][-+]?\d+)?/g;
                let numMatch;
                if (argsStr) {
                    while ((numMatch = numRegex.exec(argsStr)) !== null) {
                        args.push(parseFloat(numMatch[0]));
                    }
                }
                commands.push({ type, args });
            }
            return commands;
        }

        function normalizeSVGCommands(parsed) {
            const normalized = [];
            let cx = 0, cy = 0;
            let sx = 0, sy = 0;

            for (let i = 0; i < parsed.length; i++) {
                const cmd = parsed[i];
                const type = cmd.type;
                const args = cmd.args;

                if (type === 'M' || type === 'm') {
                    let x = args[0];
                    let y = args[1];
                    if (type === 'm') {
                        x += cx;
                        y += cy;
                    }
                    normalized.push({ type: 'M', x, y });
                    cx = x; cy = y;
                    sx = x; sy = y;

                    for (let j = 2; j < args.length; j += 2) {
                        let lx = args[j];
                        let ly = args[j+1];
                        if (type === 'm') {
                            lx += cx;
                            ly += cy;
                        }
                        normalized.push({ type: 'L', x: lx, y: ly });
                        cx = lx; cy = ly;
                    }
                } else if (type === 'L' || type === 'l') {
                    for (let j = 0; j < args.length; j += 2) {
                        let x = args[j];
                        let y = args[j+1];
                        if (type === 'l') {
                            x += cx;
                            y += cy;
                        }
                        normalized.push({ type: 'L', x, y });
                        cx = x; cy = y;
                    }
                } else if (type === 'H' || type === 'h') {
                    for (let j = 0; j < args.length; j++) {
                        let x = args[j];
                        if (type === 'h') {
                            x += cx;
                        }
                        normalized.push({ type: 'L', x, y: cy });
                        cx = x;
                    }
                } else if (type === 'V' || type === 'v') {
                    for (let j = 0; j < args.length; j++) {
                        let y = args[j];
                        if (type === 'v') {
                            y += cy;
                        }
                        normalized.push({ type: 'L', x: cx, y });
                        cy = y;
                    }
                } else if (type === 'C' || type === 'c') {
                    for (let j = 0; j < args.length; j += 6) {
                        let x1 = args[j];
                        let y1 = args[j+1];
                        let x2 = args[j+2];
                        let y2 = args[j+3];
                        let x = args[j+4];
                        let y = args[j+5];
                        if (type === 'c') {
                            x1 += cx; y1 += cy;
                            x2 += cx; y2 += cy;
                            x += cx; y += cy;
                        }
                        normalized.push({ type: 'C', x1, y1, x2, y2, x, y });
                        cx = x; cy = y;
                    }
                } else if (type === 'S' || type === 's') {
                    for (let j = 0; j < args.length; j += 4) {
                        let x2 = args[j];
                        let y2 = args[j+1];
                        let x = args[j+2];
                        let y = args[j+3];
                        if (type === 's') {
                            x2 += cx; y2 += cy;
                            x += cx; y += cy;
                        }

                        let x1, y1;
                        const prev = normalized[normalized.length - 1];
                        if (prev && prev.type === 'C') {
                            x1 = 2 * cx - prev.x2;
                            y1 = 2 * cy - prev.y2;
                        } else {
                            x1 = cx;
                            y1 = cy;
                        }

                        normalized.push({ type: 'C', x1, y1, x2, y2, x, y });
                        cx = x; cy = y;
                    }
                } else if (type === 'Q' || type === 'q') {
                    for (let j = 0; j < args.length; j += 4) {
                        let x1 = args[j];
                        let y1 = args[j+1];
                        let x = args[j+2];
                        let y = args[j+3];
                        if (type === 'q') {
                            x1 += cx; y1 += cy;
                            x += cx; y += cy;
                        }
                        normalized.push({ type: 'Q', x1, y1, x, y });
                        cx = x; cy = y;
                    }
                } else if (type === 'T' || type === 't') {
                    for (let j = 0; j < args.length; j += 2) {
                        let x = args[j];
                        let y = args[j+1];
                        if (type === 't') {
                            x += cx; y += cy;
                        }

                        let x1, y1;
                        const prev = normalized[normalized.length - 1];
                        if (prev && prev.type === 'Q') {
                            x1 = 2 * cx - prev.x1;
                            y1 = 2 * cy - prev.y1;
                        } else {
                            x1 = cx;
                            y1 = cy;
                        }

                        normalized.push({ type: 'Q', x1, y1, x, y });
                        cx = x; cy = y;
                    }
                } else if (type === 'A' || type === 'a') {
                    for (let j = 0; j < args.length; j += 7) {
                        let rx = args[j];
                        let ry = args[j+1];
                        let xar = args[j+2];
                        let laf = args[j+3];
                        let sf = args[j+4];
                        let x = args[j+5];
                        let y = args[j+6];
                        if (type === 'a') {
                            x += cx; y += cy;
                        }
                        normalized.push({ type: 'A', rx, ry, xar, laf, sf, x, y });
                        cx = x; cy = y;
                    }
                } else if (type === 'Z' || type === 'z') {
                    normalized.push({ type: 'Z' });
                    cx = sx; cy = sy;
                }
            }
            return normalized;
        }

        // Converts a normalized SVG path command list into a flat point array
        // (same {id, x, y, type} shape as addShape() produces for polygon/polyline),
        // reusing getApproximatedPoints' existing M/L/C/Q/A/Z flattening logic.
        function extractPointsFromCommands(commands, shapeIdxForIds) {
            const approx = getApproximatedPoints({ type: 'path', commands });
            return approx.map((p, pIdx) => ({
                id: `p_${shapeIdxForIds}_${pIdx}`,
                x: p.x,
                y: p.y,
                type: 'anchor'
            }));
        }

        function parseSVG(svgText) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(svgText, 'image/svg+xml');

            const svgEl = doc.querySelector('svg');
            let scaleToMM = 1.0;
            let viewBoxWidth = 800; 
            let viewBoxHeight = 600;

            if (svgEl) {
                const viewBoxAttr = svgEl.getAttribute('viewBox');
                if (viewBoxAttr) {
                    state.originalViewBox = viewBoxAttr;
                    const parts = viewBoxAttr.trim().split(/[,\s]+/).map(Number);
                    if (parts.length === 4 && parts[2] > 0 && parts[3] > 0) {
                        viewBoxWidth = parts[2];
                        viewBoxHeight = parts[3];
                    }
                }
                const wAttr = svgEl.getAttribute('width');
                const hAttr = svgEl.getAttribute('height');
                state.originalSvgWidth = wAttr ? parseFloat(wAttr) : viewBoxWidth;
                state.originalSvgHeight = hAttr ? parseFloat(hAttr) : viewBoxHeight;

                if (wAttr) {
                    const val = parseFloat(wAttr);
                    if (wAttr.includes('mm')) {
                        scaleToMM = val / viewBoxWidth;
                    } else if (wAttr.includes('in')) {
                        scaleToMM = (val * 25.4) / viewBoxWidth;
                    } else if (wAttr.includes('cm')) {
                        scaleToMM = (val * 10.0) / viewBoxWidth;
                    } else {
                        scaleToMM = (val * (25.4 / 96)) / viewBoxWidth;
                    }
                } else {
                    scaleToMM = 25.4 / 96;
                }
            }

            // --- Color extraction (item 1) ---
            // CorelDRAW and similar tools often define colors via CSS classes in a <style> block
            // (e.g. ".str0 {stroke:#E5097F}") rather than inline stroke="" attributes. Build a
            // class -> color/width lookup so we can resolve either encoding.
            const classColorMap = {};
            const classWidthMap = {};
            doc.querySelectorAll('style').forEach(styleEl => {
                const cssText = styleEl.textContent || '';
                const ruleRe = /\.([a-zA-Z0-9_-]+)\s*\{([^}]*)\}/g;
                let ruleMatch;
                while ((ruleMatch = ruleRe.exec(cssText)) !== null) {
                    const className = ruleMatch[1];
                    const body = ruleMatch[2];
                    const strokeMatch = body.match(/stroke\s*:\s*(#[0-9a-fA-F]{3,8}|rgb\([^)]+\)|[a-zA-Z]+)/);
                    if (strokeMatch) {
                        classColorMap[className] = strokeMatch[1];
                    }
                    const widthMatch = body.match(/stroke-width\s*:\s*([0-9.]+)/);
                    if (widthMatch) {
                        classWidthMap[className] = parseFloat(widthMatch[1]);
                    }
                }
            });

            const DEFAULT_SHAPE_COLOR = '#1e293b';
            // Fallback line width in mm, used when a shape carries no stroke-width info at all —
            // matches the value previously hardcoded into the exporter.
            const DEFAULT_STROKE_WIDTH_MM = 0.15;

            function extractElementColor(el) {
                // 1. Inline style="stroke:#..." takes priority
                const styleAttr = el.getAttribute('style');
                if (styleAttr) {
                    const m = styleAttr.match(/stroke\s*:\s*(#[0-9a-fA-F]{3,8}|rgb\([^)]+\)|[a-zA-Z]+)/);
                    if (m && m[1] !== 'none') return m[1];
                }
                // 2. Direct stroke="#..." attribute
                const strokeAttr = el.getAttribute('stroke');
                if (strokeAttr && strokeAttr !== 'none') return strokeAttr;
                // 3. CSS class(es) resolved via the <style> block map
                const classAttr = el.getAttribute('class');
                if (classAttr) {
                    for (const cls of classAttr.trim().split(/\s+/)) {
                        if (classColorMap[cls]) return classColorMap[cls];
                    }
                }
                return DEFAULT_SHAPE_COLOR;
            }

            // Resolves an element's stroke width, in the SVG's own user units (not yet mm-scaled —
            // multiply by scaleToMM at the call site). Same attr -> inline-style -> CSS-class
            // priority as color.
            function extractElementStrokeWidth(el) {
                const styleAttr = el.getAttribute('style');
                if (styleAttr) {
                    const m = styleAttr.match(/stroke-width\s*:\s*([0-9.]+)/);
                    if (m) return parseFloat(m[1]);
                }
                const swAttr = el.getAttribute('stroke-width');
                if (swAttr) {
                    const v = parseFloat(swAttr);
                    if (!isNaN(v)) return v;
                }
                const classAttr = el.getAttribute('class');
                if (classAttr) {
                    for (const cls of classAttr.trim().split(/\s+/)) {
                        if (classWidthMap[cls] !== undefined) return classWidthMap[cls];
                    }
                }
                return null; // caller falls back to DEFAULT_STROKE_WIDTH_MM
            }

            function resolveShapeStyle(el) {
                const rawWidth = extractElementStrokeWidth(el);
                return {
                    color: extractElementColor(el),
                    strokeWidthMm: (rawWidth !== null) ? rawWidth * scaleToMM : DEFAULT_STROKE_WIDTH_MM
                };
            }

            const parsedShapes = [];
            let shapeIdx = 0;

            function addShape(type, points, isClosed, extra = {}) {
                parsedShapes.push({
                    id: `shape_${shapeIdx}`,
                    name: `${type.toUpperCase()} #${shapeIdx + 1}`,
                    type: 'polyline',
                    originalType: `SVG_${type}`,
                    color: extra.color || DEFAULT_SHAPE_COLOR,
                    strokeWidthMm: extra.strokeWidthMm || DEFAULT_STROKE_WIDTH_MM,
                    points: points.map((p, pIdx) => ({
                        id: `p_${shapeIdx}_${pIdx}`,
                        x: p.x,
                        y: p.y,
                        type: p.type || 'anchor',
                        ...p
                    })),
                    isClosed,
                    ...extra
                });
                shapeIdx++;
            }

            doc.querySelectorAll('line').forEach(el => {
                const x1 = parseFloat(el.getAttribute('x1') || 0) * scaleToMM;
                const y1 = parseFloat(el.getAttribute('y1') || 0) * scaleToMM;
                const x2 = parseFloat(el.getAttribute('x2') || 0) * scaleToMM;
                const y2 = parseFloat(el.getAttribute('y2') || 0) * scaleToMM;
                addShape('line', [{ x: x1, y: y1 }, { x: x2, y: y2 }], false, resolveShapeStyle(el));
            });

            doc.querySelectorAll('polyline').forEach(el => {
                const pointsStr = (el.getAttribute('points') || '').trim();
                const coords = pointsStr.split(/[,\s]+/)
                    .map(s => s.trim())
                    .filter(s => s.length > 0)
                    .map(Number)
                    .filter(n => !isNaN(n));
                const pts = [];
                for (let j = 0; j + 1 < coords.length; j += 2) {
                    pts.push({ x: coords[j] * scaleToMM, y: coords[j+1] * scaleToMM });
                }
                if (pts.length > 0) addShape('polyline', pts, false, resolveShapeStyle(el));
            });

            doc.querySelectorAll('polygon').forEach(el => {
                const pointsStr = (el.getAttribute('points') || '').trim();
                const coords = pointsStr.split(/[,\s]+/)
                    .map(s => s.trim())
                    .filter(s => s.length > 0)
                    .map(Number)
                    .filter(n => !isNaN(n));
                const pts = [];
                // Only iterate over complete (x, y) pairs — ignore any dangling odd value
                for (let j = 0; j + 1 < coords.length; j += 2) {
                    pts.push({ x: coords[j] * scaleToMM, y: coords[j+1] * scaleToMM });
                }
                if (pts.length > 0) addShape('polygon', pts, true, resolveShapeStyle(el));
            });

            doc.querySelectorAll('rect').forEach(el => {
                const x = parseFloat(el.getAttribute('x') || 0) * scaleToMM;
                const y = parseFloat(el.getAttribute('y') || 0) * scaleToMM;
                const w = parseFloat(el.getAttribute('width') || 0) * scaleToMM;
                const h = parseFloat(el.getAttribute('height') || 0) * scaleToMM;
                const pts = [{ x, y }, { x: x + w, y }, { x: x + w, y: y + h }, { x, y: y + h }];
                addShape('rect', pts, true, resolveShapeStyle(el));
            });

            doc.querySelectorAll('circle').forEach(el => {
                const cx = parseFloat(el.getAttribute('cx') || 0) * scaleToMM;
                const cy = parseFloat(el.getAttribute('cy') || 0) * scaleToMM;
                const r = parseFloat(el.getAttribute('r') || 0) * scaleToMM;
                
                parsedShapes.push({
                    id: `shape_${shapeIdx}`,
                    name: `CIRCLE #${shapeIdx + 1}`,
                    type: 'circle',
                    originalType: 'SVG_circle',
                    color: extractElementColor(el),
                    strokeWidthMm: (extractElementStrokeWidth(el) !== null) ? extractElementStrokeWidth(el) * scaleToMM : DEFAULT_STROKE_WIDTH_MM,
                    cx, cy, r,
                    isClosed: true,
                    points: [
                        { id: `p_${shapeIdx}_c`, x: cx, y: cy, type: 'center', prop: 'center' },
                        { id: `p_${shapeIdx}_r`, x: cx + r, y: cy, type: 'radius', prop: 'radius' }
                    ]
                });
                shapeIdx++;
            });

            doc.querySelectorAll('ellipse').forEach(el => {
                const cx = parseFloat(el.getAttribute('cx') || 0) * scaleToMM;
                const cy = parseFloat(el.getAttribute('cy') || 0) * scaleToMM;
                const rx = parseFloat(el.getAttribute('rx') || 0) * scaleToMM;
                const ry = parseFloat(el.getAttribute('ry') || 0) * scaleToMM;
                
                parsedShapes.push({
                    id: `shape_${shapeIdx}`,
                    name: `ELLIPSE #${shapeIdx + 1}`,
                    type: 'ellipse',
                    originalType: 'SVG_ellipse',
                    color: extractElementColor(el),
                    strokeWidthMm: (extractElementStrokeWidth(el) !== null) ? extractElementStrokeWidth(el) * scaleToMM : DEFAULT_STROKE_WIDTH_MM,
                    cx, cy, rx, ry,
                    isClosed: true,
                    points: [
                        { id: `p_${shapeIdx}_c`, x: cx, y: cy, type: 'center', prop: 'center' },
                        { id: `p_${shapeIdx}_rx`, x: cx + rx, y: cy, type: 'rx', prop: 'rx' },
                        { id: `p_${shapeIdx}_ry`, x: cx, y: cy + ry, type: 'ry', prop: 'ry' }
                    ]
                });
                shapeIdx++;
            });

            doc.querySelectorAll('path').forEach(el => {
                const d = el.getAttribute('d') || '';
                const parsedCmds = parseSVGPathString(d);
                const normalized = normalizeSVGCommands(parsedCmds);
                
                normalized.forEach(cmd => {
                    if (cmd.x !== undefined) cmd.x *= scaleToMM;
                    if (cmd.y !== undefined) cmd.y *= scaleToMM;
                    if (cmd.x1 !== undefined) cmd.x1 *= scaleToMM;
                    if (cmd.y1 !== undefined) cmd.y1 *= scaleToMM;
                    if (cmd.x2 !== undefined) cmd.x2 *= scaleToMM;
                    if (cmd.y2 !== undefined) cmd.y2 *= scaleToMM;
                    if (cmd.rx !== undefined) cmd.rx *= scaleToMM;
                    if (cmd.ry !== undefined) cmd.ry *= scaleToMM;
                });

                parsedShapes.push({
                    id: `shape_${shapeIdx}`,
                    name: `PATH #${shapeIdx + 1}`,
                    type: 'path',
                    originalType: 'SVG_path',
                    color: extractElementColor(el),
                    strokeWidthMm: (extractElementStrokeWidth(el) !== null) ? extractElementStrokeWidth(el) * scaleToMM : DEFAULT_STROKE_WIDTH_MM,
                    commands: normalized,
                    points: extractPointsFromCommands(normalized, shapeIdx),
                    isClosed: normalized.some(cmd => cmd.type === 'Z' || cmd.type === 'z')
                });
                shapeIdx++;
            });

            return parsedShapes;
        }

        // ==========================================
        // Geometry Approximation (For Sizing Heuristics)
        // ==========================================
        function getApproximatedPoints(shape) {
            const pts = [];
            if (shape.type === 'polyline') {
                shape.points.forEach((pt, i) => {
                    if (i > 0 && shape.points[i-1].bulge) {
                        const pPrev = shape.points[i-1];
                        const evalPts = evaluateBulgePoints(pPrev.x, pPrev.y, pt.x, pt.y, pPrev.bulge, 10);
                        pts.push(...evalPts);
                    } else {
                        pts.push({ x: pt.x, y: pt.y });
                    }
                });
                if (shape.isClosed && shape.points.length > 2) {
                    const lastPt = shape.points[shape.points.length - 1];
                    if (lastPt.bulge) {
                        const evalPts = evaluateBulgePoints(lastPt.x, lastPt.y, shape.points[0].x, shape.points[0].y, lastPt.bulge, 10);
                        pts.push(...evalPts);
                    } else {
                        pts.push({ x: shape.points[0].x, y: shape.points[0].y });
                    }
                }
            } else if (shape.type === 'circle') {
                for (let a = 0; a <= 2 * Math.PI; a += Math.PI / 18) {
                    pts.push({ x: shape.cx + shape.r * Math.cos(a), y: shape.cy + shape.r * Math.sin(a) });
                }
            } else if (shape.type === 'ellipse') {
                for (let a = 0; a <= 2 * Math.PI; a += Math.PI / 18) {
                    pts.push({ x: shape.cx + shape.rx * Math.cos(a), y: shape.cy + shape.ry * Math.sin(a) });
                }
            } else if (shape.type === 'arc') {
                const saRad = (shape.startAngle * Math.PI) / 180;
                const eaRad = (shape.endAngle * Math.PI) / 180;
                let delta = eaRad - saRad;
                if (delta < 0) delta += 2 * Math.PI;
                for (let t = 0; t <= 1; t += 0.05) {
                    const a = saRad + delta * t;
                    pts.push({ x: shape.cx + shape.r * Math.cos(a), y: shape.cy + shape.r * Math.sin(a) });
                }
            } else if (shape.type === 'path') {
                let cx = 0, cy = 0;
                let sx = 0, sy = 0;
                let firstMoveSeen = false;
                shape.commands.forEach(cmd => {
                    if (cmd.type === 'M') {
                        // A second (or later) M starts an independent subpath — mark it so
                        // consumers (bbox is fine either way, but drawing/export code) restart
                        // the pen instead of drawing a phantom line from the previous subpath's
                        // last point to this one.
                        pts.push({ x: cmd.x, y: cmd.y, break: firstMoveSeen });
                        firstMoveSeen = true;
                        cx = cmd.x; cy = cmd.y;
                        sx = cmd.x; sy = cmd.y;
                    } else if (cmd.type === 'L') {
                        pts.push({ x: cmd.x, y: cmd.y });
                        cx = cmd.x; cy = cmd.y;
                    } else if (cmd.type === 'C') {
                        const flat = flattenCubicBezier(cx, cy, cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
                        pts.push(...flat);
                        cx = cmd.x; cy = cmd.y;
                    } else if (cmd.type === 'Q') {
                        const flat = flattenQuadraticBezier(cx, cy, cmd.x1, cmd.y1, cmd.x, cmd.y);
                        pts.push(...flat);
                        cx = cmd.x; cy = cmd.y;
                    } else if (cmd.type === 'A') {
                        const centerParams = svgArcToCenter(cx, cy, cmd.rx, cmd.ry, cmd.xAxisRotation || cmd.xar, cmd.laf, cmd.sf, cmd.x, cmd.y);
                        if (!centerParams) {
                            pts.push({ x: cmd.x, y: cmd.y });
                        } else {
                            const saRad = centerParams.startAngle;
                            const eaRad = centerParams.endAngle;
                            let delta = eaRad - saRad;
                            const steps = 12;
                            for (let k = 1; k <= steps; k++) {
                                const t = k / steps;
                                const a = saRad + delta * t;
                                const ex = centerParams.rx * Math.cos(a);
                                const ey = centerParams.ry * Math.sin(a);
                                const rot = ((centerParams.xAxisRotation || 0) * Math.PI) / 180;
                                const x = centerParams.cx + ex * Math.cos(rot) - ey * Math.sin(rot);
                                const y = centerParams.cy + ex * Math.sin(rot) + ey * Math.cos(rot);
                                pts.push({ x, y });
                            }
                        }
                        cx = cmd.x; cy = cmd.y;
                    } else if (cmd.type === 'Z') {
                        pts.push({ x: sx, y: sy });
                        cx = sx; cy = sy;
                    }
                });
            }
            return pts;
        }

        function getShapesBoundingBox(shapesList) {
            let minX = Infinity, minY = Infinity;
            let maxX = -Infinity, maxY = -Infinity;

            shapesList.forEach(shape => {
                const approxPts = getApproximatedPoints(shape);
                approxPts.forEach(pt => {
                    if (pt.x < minX) minX = pt.x;
                    if (pt.x > maxX) maxX = pt.x;
                    if (pt.y < minY) minY = pt.y;
                    if (pt.y > maxY) maxY = pt.y;
                });
            });

            if (minX === Infinity) return { minX: 0, minY: 0, maxX: 0, maxY: 0, width: 0, height: 0 };
            return {
                minX, minY, maxX, maxY,
                width: maxX - minX,
                height: maxY - minY
            };
        }

        // ==========================================
        // Sizing & Thickness Heuristics
        // ==========================================
        function isPerpendicular(A, B, C) {
            const dx1 = B.x - A.x;
            const dy1 = B.y - A.y;
            const dx2 = C.x - B.x;
            const dy2 = C.y - B.y;

            const len1 = Math.sqrt(dx1*dx1 + dy1*dy1);
            const len2 = Math.sqrt(dx2*dx2 + dy2*dy2);
            if (len1 < 0.001 || len2 < 0.001) return false;

            const dot = dx1*dx2 + dy1*dy2;
            const cosAngle = dot / (len1 * len2);
            return Math.abs(cosAngle) < 0.15; 
        }

        function analyzeDrawingSizeAndThickness() {
            if (state.shapes.length === 0) return;

            // The displayed original layout dimensions (and everything scaling depends
            // on) is the bounding box of the WHOLE drawing — every shape combined — matching what
            // the blue on-screen ruler measures. Using only the single largest closed contour here
            // would make the panel disagree with the ruler on any file with multiple separate
            // parts (a full sheet layout, not just one panel).
            const targetBBox = getShapesBoundingBox(state.shapes);

            // Round to hundredths here (not just at display time) so SVG and DXF versions of the
            // same drawing report an identical size. The residual ~0.001mm-scale difference between
            // formats comes from cubic-bezier (SVG) vs NURBS (DXF) being genuinely different curve
            // representations of the same shape — not fixable by tighter sampling — so rounding at
            // this level is what actually makes both agree, rather than just hiding the difference
            // by truncating the display.
            state.originalWidth = Math.round(targetBBox.width * 100) / 100;
            state.originalHeight = Math.round(targetBBox.height * 100) / 100;

            const candidates = [];
            state.shapes.forEach(shape => {
                // Heuristic A: Small rectangular slots.
                // Covers <rect> elements, 5-point closed polylines (first point repeated to close),
                // AND 4-point closed polygons — SVG <polygon> is implicitly closed per spec, so many
                // exporters (CorelDRAW included) emit exactly 4 points without repeating the first
                // one. Missing that case meant every polygon-based rectangular slot was silently
                // skipped, even when it's the clearest thickness evidence in the file.
                const isRectCandidate =
                    shape.originalType === 'SVG_rect' || shape.type === 'rect' ||
                    (shape.type === 'polyline' && shape.isClosed &&
                        (shape.points.length === 5 || shape.points.length === 4));

                if (isRectCandidate) {
                    const pts = shape.points;
                    const side1 = dist(pts[0], pts[1]);
                    const side2 = dist(pts[1], pts[2]);
                    const side3 = dist(pts[2], pts[3]);
                    // For a true rectangle, opposite sides match — check this so we don't
                    // misread an arbitrary 4-sided closed shape as a slot.
                    const isRectangular = pts.length >= 4 && Math.abs(side1 - side3) < Math.max(side1, side3) * 0.05;

                    if (isRectangular || pts.length === 5) {
                        const minDim = Math.min(side1, side2);
                        const maxDim = Math.max(side1, side2);

                        if (minDim >= 1.0 && minDim <= 20.0 && maxDim > minDim * 1.3) {
                            candidates.push(minDim);
                        }
                    }
                }

                // Heuristic C: Rectangular fill-ratio test for curve-derived small closed shapes.
                // A rectangular slot exported as a SPLINE (smoothed/flattened into many points
                // rather than 4 straight corners) still fills essentially 100% of its own bounding
                // box — unlike a rounded/decorative closed curve, which fills noticeably less.
                // This lets us find genuine rectangular pass-through holes even when the file has
                // no straight-line geometry at all for Heuristics A/B to work with.
                if (shape.isClosed && shape.points.length > 5) {
                    const bbox = getShapesBoundingBox([shape]);
                    if (bbox.width >= 1.0 && bbox.width <= 20.0 && bbox.height >= 1.0 && bbox.height <= 20.0) {
                        const minDim = Math.min(bbox.width, bbox.height);
                        const maxDim = Math.max(bbox.width, bbox.height);
                        if (maxDim > minDim * 1.3) {
                            const flatPts = getApproximatedPoints(shape);
                            if (flatPts.length >= 4) {
                                let area = 0;
                                for (let j = 0; j < flatPts.length; j++) {
                                    const k = (j + 1) % flatPts.length;
                                    area += flatPts[j].x * flatPts[k].y - flatPts[k].x * flatPts[j].y;
                                }
                                area = Math.abs(area) / 2;
                                const fillRatio = area / (bbox.width * bbox.height);
                                if (fillRatio > 0.85) {
                                    candidates.push(minDim);
                                }
                            }
                        }
                    }
                }

                // Heuristic B: Scan joint tabs / alternating steps.
                // Restricted to straight-line geometry only — bezier curves get flattened into
                // many short chords by getApproximatedPoints, and isPerpendicular's angle
                // tolerance frequently misreads curve segments as finger-joint tabs, which can
                // outnumber genuine joints in files with decorative curved artwork. A <path>
                // built entirely from M/L/Z (no curve commands) is just as safe as a polyline
                // though — many box-panel exporters (CorelDRAW, BoxDesigner) draw straight-edged
                // panels as <path> rather than <polygon>, and blanket-excluding all paths meant
                // those files could never get a confident thickness reading.
                const hasCurveCommand = shape.type === 'path' && shape.commands &&
                    shape.commands.some(c => c.type === 'C' || c.type === 'Q' || c.type === 'A');
                const isStraightPath = shape.type === 'path' && !hasCurveCommand;

                if ((shape.type === 'polyline' || isStraightPath) &&
                    shape.originalType !== 'SPLINE') {
                    const pts = getApproximatedPoints(shape);
                    // A plain rectangle (4-5 points incl. closing point) is all-90-degree by
                    // definition and will always "pass" isPerpendicular at every corner — that's
                    // just its own outline, not a finger-joint tab. A real joint tab is a short
                    // step embedded WITHIN a longer edge, so the containing contour needs enough
                    // points that the step is a sub-feature, not the whole shape.
                    if (pts.length < 8) return;

                    const shapeSteps = [];
                    for (let j = 0; j < pts.length - 3; j++) {
                        const A = pts[j];
                        const B = pts[j+1];
                        const C = pts[j+2];
                        const D = pts[j+3];

                        if (isPerpendicular(A, B, C) && isPerpendicular(B, C, D)) {
                            const stepLen = dist(B, C);
                            if (stepLen >= 1.0 && stepLen <= 20.0) {
                                shapeSteps.push(stepLen);
                            }
                        }
                    }
                    // A genuine finger-joint edge produces a *series* of repeating tabs along the
                    // same edge. A single coincidental match is not strong evidence — require at
                    // least 2 within this one shape before trusting them.
                    if (shapeSteps.length >= 2) {
                        candidates.push(...shapeSteps);
                    }
                }
            });

            const groups = [];
            candidates.forEach(c => {
                let found = false;
                for (let g of groups) {
                    if (Math.abs(g.avg - c) < 0.25) { 
                        g.values.push(c);
                        g.avg = g.values.reduce((sum, v) => sum + v, 0) / g.values.length;
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    groups.push({ avg: c, values: [c] });
                }
            });

            groups.sort((a, b) => b.values.length - a.values.length);

            // Within the winning group, prefer the mode (most common rounded reading) over the
            // arithmetic mean. A handful of curve-approximation outliers (e.g. a NURBS-flattened
            // slot reading 2.919mm instead of exactly 3.000mm) shouldn't drag the result away from
            // the value the vast majority of measurements actually agree on.
            function modeOf(values) {
                const rounded = values.map(v => Math.round(v * 1000) / 1000);
                const counts = {};
                rounded.forEach(v => { counts[v] = (counts[v] || 0) + 1; });
                let bestVal = rounded[0], bestCount = 0;
                for (const [val, count] of Object.entries(counts)) {
                    if (count > bestCount) { bestCount = count; bestVal = parseFloat(val); }
                }
                return bestVal;
            }

            if (groups.length > 0 && groups[0].values.length >= 2) {
                state.detectedThickness = modeOf(groups[0].values);
                state.thicknessConfidence = groups[0].values.length >= 6 ? 'High' : 'Medium';
            } else if (groups.length > 0) {
                state.detectedThickness = modeOf(groups[0].values);
                state.thicknessConfidence = 'Low';
            } else {
                state.detectedThickness = 3.0; 
                state.thicknessConfidence = 'None';
            }

            state.confirmedThickness = state.detectedThickness;
        }

        // ==========================================
        // Viewport Rendering Loop
        // ==========================================

        function drawShape(ctx, shape, sx, sy, currentScale) {
            ctx.strokeStyle = shape.color || '#1e293b';
            // ctx.lineWidth is set here while a ctx.scale(currentScale, currentScale) transform is
            // already active (see drawBoth) — the canvas multiplies lineWidth by that same scale
            // internally, so setting mmWidth * currentScale here would render at
            // mmWidth * currentScale^2 actual pixels (quadratic, not linear). Dividing by
            // currentScale here cancels the transform's multiplication, giving the correct
            // mmWidth * currentScale physical line thickness regardless of zoom level.
            const mmWidth = shape.strokeWidthMm || 0.15;
            ctx.lineWidth = Math.max(mmWidth, 0.35 / currentScale);

            if (shape.type === 'polyline') {
                ctx.beginPath();
                shape.points.forEach((pt, idx) => {
                    const px = pt.x * sx;
                    const py = pt.y * sy;
                    if (idx === 0) {
                        ctx.moveTo(px, py);
                    } else {
                        const prevPt = shape.points[idx - 1];
                        if (prevPt.bulge && prevPt.bulge !== 0) {
                            drawBulge(ctx, prevPt.x * sx, prevPt.y * sy, px, py, prevPt.bulge);
                        } else {
                            ctx.lineTo(px, py);
                        }
                    }
                });
                if (shape.isClosed && shape.points.length > 2) {
                    const lastPt = shape.points[shape.points.length - 1];
                    if (lastPt.bulge && lastPt.bulge !== 0) {
                        drawBulge(ctx, lastPt.x * sx, lastPt.y * sy, shape.points[0].x * sx, shape.points[0].y * sy, lastPt.bulge);
                    } else {
                        ctx.closePath();
                    }
                }
                ctx.stroke();

            } else if (shape.type === 'circle') {
                ctx.beginPath();
                if (Math.abs(sx - sy) < 0.0001) {
                    ctx.arc(shape.cx * sx, shape.cy * sy, shape.r * sx, 0, 2 * Math.PI);
                } else {
                    ctx.ellipse(shape.cx * sx, shape.cy * sy, shape.r * sx, shape.r * sy, 0, 0, 2 * Math.PI);
                }
                ctx.stroke();

            } else if (shape.type === 'ellipse') {
                ctx.beginPath();
                ctx.ellipse(shape.cx * sx, shape.cy * sy, shape.rx * sx, shape.ry * sy, 0, 0, 2 * Math.PI);
                ctx.stroke();

            } else if (shape.type === 'arc') {
                if (Math.abs(sx - sy) > 0.0001) {
                    const pts = getApproximatedPoints(shape);
                    ctx.beginPath();
                    pts.forEach((pt, idx) => {
                        if (idx === 0) ctx.moveTo(pt.x * sx, pt.y * sy);
                        else ctx.lineTo(pt.x * sx, pt.y * sy);
                    });
                    ctx.stroke();
                } else {
                    ctx.beginPath();
                    const saRad = (shape.startAngle * Math.PI) / 180;
                    const eaRad = (shape.endAngle * Math.PI) / 180;
                    ctx.arc(shape.cx * sx, shape.cy * sy, shape.r * sx, saRad, eaRad, false);
                    ctx.stroke();
                }

            } else if (shape.type === 'path') {
                ctx.beginPath();
                let cx = 0, cy = 0;
                let sx_start = 0, sy_start = 0;

                shape.commands.forEach(cmd => {
                    if (cmd.type === 'M') {
                        ctx.moveTo(cmd.x * sx, cmd.y * sy);
                        cx = cmd.x; cy = cmd.y;
                        sx_start = cmd.x; sy_start = cmd.y;
                    } else if (cmd.type === 'L') {
                        ctx.lineTo(cmd.x * sx, cmd.y * sy);
                        cx = cmd.x; cy = cmd.y;
                    } else if (cmd.type === 'C') {
                        ctx.bezierCurveTo(cmd.x1 * sx, cmd.y1 * sy, cmd.x2 * sx, cmd.y2 * sy, cmd.x * sx, cmd.y * sy);
                        cx = cmd.x; cy = cmd.y;
                    } else if (cmd.type === 'Q') {
                        ctx.quadraticCurveTo(cmd.x1 * sx, cmd.y1 * sy, cmd.x * sx, cmd.y * sy);
                        cx = cmd.x; cy = cmd.y;
                    } else if (cmd.type === 'A') {
                        if (Math.abs(sx - sy) < 0.0001) {
                            const centerParams = svgArcToCenter(cx, cy, cmd.rx, cmd.ry, cmd.xAxisRotation || cmd.xar, cmd.laf, cmd.sf, cmd.x, cmd.y);
                            if (!centerParams) {
                                ctx.lineTo(cmd.x * sx, cmd.y * sy);
                            } else {
                                ctx.save();
                                ctx.translate(centerParams.cx * sx, centerParams.cy * sy);
                                ctx.rotate((centerParams.xAxisRotation * Math.PI) / 180);
                                ctx.scale(centerParams.rx * sx, centerParams.ry * sy);
                                ctx.arc(0, 0, 1, centerParams.startAngle, centerParams.endAngle, centerParams.anticlockwise);
                                ctx.restore();
                            }
                        } else {
                            const centerParams = svgArcToCenter(cx, cy, cmd.rx, cmd.ry, cmd.xAxisRotation || cmd.xar, cmd.laf, cmd.sf, cmd.x, cmd.y);
                            if (!centerParams) {
                                ctx.lineTo(cmd.x * sx, cmd.y * sy);
                            } else {
                                const saRad = centerParams.startAngle;
                                const eaRad = centerParams.endAngle;
                                let delta = eaRad - saRad;
                                const steps = 12;
                                for (let k = 1; k <= steps; k++) {
                                    const t = k / steps;
                                    const a = saRad + delta * t;
                                    const ex = centerParams.rx * Math.cos(a);
                                    const ey = centerParams.ry * Math.sin(a);
                                    const rot = ((centerParams.xAxisRotation || 0) * Math.PI) / 180;
                                    const rx_val = centerParams.cx + ex * Math.cos(rot) - ey * Math.sin(rot);
                                    const ry_val = centerParams.cy + ex * Math.sin(rot) + ey * Math.cos(rot);
                                    ctx.lineTo(rx_val * sx, ry_val * sy);
                                }
                            }
                        }
                        cx = cmd.x; cy = cmd.y;
                    } else if (cmd.type === 'Z' || cmd.type === 'z') {
                        ctx.closePath();
                        cx = sx_start; cy = sy_start;
                    }
                });
                ctx.stroke();
            }
        }

        function drawBulge(ctx, x1, y1, x2, y2, bulge) {
            if (Math.abs(bulge) < 0.001) {
                ctx.lineTo(x2, y2);
                return;
            }
            const b = bulge;
            const dx = x2 - x1;
            const dy = y2 - y1;
            const L = Math.sqrt(dx * dx + dy * dy);
            if (L < 0.0001) return;

            const r = L * (1 + b * b) / (4 * Math.abs(b));
            const s = b * L / 2;
            const h = r - Math.abs(s);

            const mx = (x1 + x2) / 2;
            const my = (y1 + y2) / 2;

            const nx = -dy / L;
            const ny = dx / L;

            const dir = b > 0 ? 1 : -1;
            const signOfH = (Math.abs(b) <= 1.0) ? 1 : -1;
            const cx = mx - dir * signOfH * h * nx;
            const cy = my - dir * signOfH * h * ny;

            const startAngle = Math.atan2(y1 - cy, x1 - cx);
            const endAngle = Math.atan2(y2 - cy, x2 - cx);

            const anticlockwise = b < 0; 
            ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        }

        function drawCADDimensions(ctx, shapesList, sx, sy, currentScale) {
            const box = getShapesBoundingBox(shapesList);
            if (box.width === 0 || box.height === 0) return;

            const unit = state.displayUnit;
            const factor = (unit === 'in') ? 1 / 25.4 : 1.0;
            const precision = (unit === 'in') ? 2 : 1;

            const wText = (box.width * sx * factor).toFixed(precision) + ' ' + unit;
            const hText = (box.height * sy * factor).toFixed(precision) + ' ' + unit;

            const offset = 30 / currentScale; 
            const tickSize = 6 / currentScale; 

            ctx.save();
            ctx.strokeStyle = '#2563eb';
            ctx.fillStyle = '#2563eb';
            ctx.lineWidth = 1.0 / currentScale;
            ctx.font = `${11 / currentScale}px sans-serif`;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            // ---- Horizontal Dimension (Width) ----
            const xStart = box.minX * sx;
            const xEnd = box.maxX * sx;
            const yDim = box.maxY * sy + offset;

            ctx.beginPath();
            ctx.moveTo(xStart, yDim);
            ctx.lineTo(xEnd, yDim);
            ctx.stroke();

            // End ticks
            ctx.beginPath();
            ctx.moveTo(xStart, yDim - tickSize/2);
            ctx.lineTo(xStart, yDim + tickSize/2);
            ctx.moveTo(xEnd, yDim - tickSize/2);
            ctx.lineTo(xEnd, yDim + tickSize/2);
            ctx.stroke();

            drawArrow(ctx, xStart, yDim, xStart + 8/currentScale, yDim, currentScale);
            drawArrow(ctx, xEnd, yDim, xEnd - 8/currentScale, yDim, currentScale);

            ctx.save();
            const wTextWidth = ctx.measureText(wText).width;
            ctx.fillStyle = '#ffffff';
            ctx.fillRect((xStart + xEnd)/2 - wTextWidth/2 - 4/currentScale, yDim - 7/currentScale, wTextWidth + 8/currentScale, 14/currentScale);
            ctx.restore();

            ctx.fillText(wText, (xStart + xEnd)/2, yDim);

            // ---- Vertical Dimension (Height) ----
            const yStart = box.minY * sy;
            const yEnd = box.maxY * sy;
            const xDim = box.minX * sx - offset;

            ctx.beginPath();
            ctx.moveTo(xDim, yStart);
            ctx.lineTo(xDim, yEnd);
            ctx.stroke();

            // End ticks
            ctx.beginPath();
            ctx.moveTo(xDim - tickSize/2, yStart);
            ctx.lineTo(xDim + tickSize/2, yStart);
            ctx.moveTo(xDim - tickSize/2, yEnd);
            ctx.lineTo(xDim + tickSize/2, yEnd);
            ctx.stroke();

            drawArrow(ctx, xDim, yStart, xDim, yStart + 8/currentScale, currentScale);
            drawArrow(ctx, xDim, yEnd, xDim, yEnd - 8/currentScale, currentScale);

            ctx.save();
            ctx.translate(xDim, (yStart + yEnd)/2);
            ctx.rotate(-Math.PI / 2);
            const hTextWidth = ctx.measureText(hText).width;
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(-hTextWidth/2 - 4/currentScale, -7/currentScale, hTextWidth + 8/currentScale, 14/currentScale);
            ctx.restore();

            ctx.save();
            ctx.translate(xDim, (yStart + yEnd)/2);
            ctx.rotate(-Math.PI / 2);
            ctx.fillText(hText, 0, 0);
            ctx.restore();

            ctx.restore();
        }

        function drawArrow(ctx, x1, y1, x2, y2, currentScale) {
            const angle = Math.atan2(y2 - y1, x2 - x1);
            const arrowSize = 5 / currentScale;
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.lineTo(x1 + arrowSize * Math.cos(angle - Math.PI/6), y1 + arrowSize * Math.sin(angle - Math.PI/6));
            ctx.lineTo(x1 + arrowSize * Math.cos(angle + Math.PI/6), y1 + arrowSize * Math.sin(angle + Math.PI/6));
            ctx.closePath();
            ctx.fill();
        }

        function getViewportBoundingBox(shapesList) {
            const closedShapes = shapesList.filter(s => s.isClosed);
            if (closedShapes.length > 0) {
                return getShapesBoundingBox(closedShapes);
            }
            return getShapesBoundingBox(shapesList);
        }

        function drawBoth() {
            const ctxOrig = els.canvasOriginal.getContext('2d');
            const ctxScaled = els.canvasScaled.getContext('2d');

            if (state.shapes.length === 0) {
                ctxOrig.clearRect(0, 0, els.canvasOriginal.clientWidth, els.canvasOriginal.clientHeight);
                ctxScaled.clearRect(0, 0, els.canvasScaled.clientWidth, els.canvasScaled.clientHeight);
                return;
            }

            const bboxOrig = getViewportBoundingBox(state.shapes);
            const bboxScaled = {
                minX: bboxOrig.minX * state.scaleX,
                maxX: bboxOrig.maxX * state.scaleX,
                minY: bboxOrig.minY * state.scaleY,
                maxY: bboxOrig.maxY * state.scaleY,
                width: bboxOrig.width * state.scaleX,
                height: bboxOrig.height * state.scaleY
            };

            const pxPerMm = state.currentPxPerMm || 1.0;
            const padLeft = state.currentPadLeft || 42;
            const padTop = state.currentPadTop || 14;

            const offsetXOrig = padLeft - bboxOrig.minX * pxPerMm;
            const offsetYOrig = padTop - bboxOrig.minY * pxPerMm;

            const offsetXScaled = padLeft - bboxScaled.minX * pxPerMm;
            const offsetYScaled = padTop - bboxScaled.minY * pxPerMm;

            // Original Card (Left)
            ctxOrig.clearRect(0, 0, els.canvasOriginal.clientWidth, els.canvasOriginal.clientHeight);
            ctxOrig.save();
            ctxOrig.translate(offsetXOrig, offsetYOrig);
            ctxOrig.scale(pxPerMm, pxPerMm);
            
            state.shapes.forEach(shape => {
                drawShape(ctxOrig, shape, 1.0, 1.0, pxPerMm);
            });
            drawCADDimensions(ctxOrig, state.shapes, 1.0, 1.0, pxPerMm);
            ctxOrig.restore();

            // Scaled Card (Right)
            ctxScaled.clearRect(0, 0, els.canvasScaled.clientWidth, els.canvasScaled.clientHeight);
            ctxScaled.save();
            ctxScaled.translate(offsetXScaled, offsetYScaled);
            ctxScaled.scale(pxPerMm, pxPerMm);
            
            state.shapes.forEach(shape => {
                drawShape(ctxScaled, shape, state.scaleX, state.scaleY, pxPerMm);
            });
            drawCADDimensions(ctxScaled, state.shapes, state.scaleX, state.scaleY, pxPerMm);
            ctxScaled.restore();
        }

        // ==========================================
        // File Loader & Parser Dispatcher
        // ==========================================
        function loadFile(file) {
            state.filename = file.name;
            const ext = state.filename.split('.').pop().toLowerCase();
            state.fileType = ext;

            const reader = new FileReader();
            reader.onload = function(e) {
                const contents = e.target.result;
                state.originalText = contents;
                try {
                    if (ext === 'dxf') {
                        state.shapes = parseDXF(contents);
                    } else if (ext === 'svg') {
                        state.shapes = parseSVG(contents);
                    } else {
                        throw new Error('Unsupported file format. Upload an SVG or DXF file.');
                    }

                    if (state.shapes.length === 0) {
                        throw new Error('No supported vector geometry was found in this file.');
                    }

                    state.hasFile = true;
                    appRoot.classList.add('has-loaded-file');

                    analyzeDrawingSizeAndThickness();

                    state.confirmedThickness = state.detectedThickness;
                    state.targetThickness = state.detectedThickness;

                    state.scaleX = 1.0;
                    state.scaleY = 1.0;
                    state.scalePercent = 100.0;
                    state.newWidth = state.originalWidth;
                    state.newHeight = state.originalHeight;

                    els.groupAnalysis.style.display = 'block';
                    els.groupThicknessConfirm.style.display = 'block';
                    els.groupExport.style.display = 'block';
                    els.btnExportLabel.innerText = `Download ${ext.toUpperCase()}`;

                    syncUIValues();
                    // Defer to the next frame because the newly shown mobile panels and preview
                    // cards change the page geometry; sizing canvases in the same tick can capture
                    // stale dimensions immediately after import.
                    requestAnimationFrame(() => resizeCanvases());
                    showToast('File Imported', `${state.shapes.length} vector contours found.`, 'success');

                } catch (err) {
                    console.error(err);
                    showToast('Import Error', `Couldn’t process this file: ${err.message}`, 'error');
                }
            };

            reader.readAsText(file);
        }

        // Matches a DXF's approximate ACI-index colors against a paired SVG's exact RGB colors,
        // by comparing which color is most frequent in each file. The original CAD/illustration
        // tool's real ACI->color mapping only exists inside that tool (CorelDRAW, etc.) — the DXF
        // itself only stores the index, never the exact color it displayed. But if the person also
        // has the matching SVG export (which DOES store exact RGB per shape), the two files were
        // generated from the same source drawing, so each distinct ACI index used in the DXF should
        // correspond to exactly one distinct color in the SVG, in the same rank order by how many
        // shapes use it. This recovers the tool's real colors from real project data, rather than
        // guessing from AutoCAD's standard (and possibly different) palette.
        // ==========================================
        // UI Synchronizers & Unit Toggles
        // ==========================================
        function fmtVal(val, useUnit = true, precision = 3, trimZeros = true) {
            const unit = state.displayUnit;
            const converted = (unit === 'in') ? val / 25.4 : val;
            const fixed = converted.toFixed(precision);
            const trimmed = trimZeros ? fixed.replace(/0+$/, '').replace(/\.$/, '') : fixed;
            return trimmed + (useUnit ? ' ' + unit : '');
        }

        function syncUIValues() {
            if (!state.hasFile) return;

            const unit = state.displayUnit;

            els.detOuterWidth.innerText = fmtVal(state.originalWidth, true, 3, false);
            els.detOuterHeight.innerText = fmtVal(state.originalHeight, true, 3, false);
            els.detThickness.innerText = fmtVal(state.detectedThickness);
            els.detThicknessConf.innerText = state.thicknessConfidence === 'None' ? 'Needs confirmation' : state.thicknessConfidence;
            
            els.detThicknessConf.className = 'info-badge';
            if (state.thicknessConfidence === 'High') {
                els.detThicknessConf.style.background = 'rgba(16, 185, 129, 0.15)';
                els.detThicknessConf.style.borderColor = 'rgba(16, 185, 129, 0.3)';
                els.detThicknessConf.style.color = '#10b981';
            } else if (state.thicknessConfidence === 'Medium') {
                els.detThicknessConf.style.background = 'rgba(245, 158, 11, 0.15)';
                els.detThicknessConf.style.borderColor = 'rgba(245, 158, 11, 0.3)';
                els.detThicknessConf.style.color = '#f59e0b';
            } else {
                els.detThicknessConf.style.background = 'rgba(239, 68, 68, 0.15)';
                els.detThicknessConf.style.borderColor = 'rgba(239, 68, 68, 0.3)';
                els.detThicknessConf.style.color = '#ef4444';
            }

            const unitMult = (unit === 'in') ? 1/25.4 : 1.0;
            appRoot.querySelectorAll('.text-unit').forEach(label => {
                label.innerText = unit;
            });

            refreshThicknessDisplays();

            els.headerThicknessOriginal.innerHTML = `Thickness: <strong>${fmtVal(state.confirmedThickness)}</strong>`;
            els.headerThicknessScaled.innerHTML = `Thickness: <strong>${fmtVal(state.targetThickness)}</strong>`;

            els.txtFooterOriginal.innerHTML = `Layout Dimensions: <strong>${fmtVal(state.originalWidth, true, 3, false)} × ${fmtVal(state.originalHeight, true, 3, false)}</strong>`;

            els.txtFooterScaled.innerHTML = `Layout Dimensions: <strong>${fmtVal(state.newWidth, true, 3, false)} × ${fmtVal(state.newHeight, true, 3, false)}</strong>`;

            els.badgeScaledPct.innerText = `Scale (${state.scalePercent.toFixed(2).replace(/\.?0+$/, '')}%)`;
        }

        // Formats a millimeter value for display in an input field: up to 3 decimal places,
        // trimming trailing zeros (item 3 — allow up to 3 decimals; avoids forcing e.g. "3.000").
        function formatThicknessForInput(mmVal, unit) {
            const unitMult = (unit === 'in') ? 1 / MM_PER_INCH : 1.0;
            const val = mmVal * unitMult;
            let str = val.toFixed(3);
            str = str.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
            return str;
        }

        // Refreshes the two thickness input fields and their preset dropdowns from state,
        // but skips a field that currently has focus (mid-edit) so it never fights the user's typing.
        function refreshThicknessDisplays() {
            const unit = state.displayUnit;
            if (document.activeElement !== els.inputOverrideThickness) {
                els.inputOverrideThickness.value = formatThicknessForInput(state.confirmedThickness, unit);
            }
            if (document.activeElement !== els.inputTargetThickness) {
                els.inputTargetThickness.value = formatThicknessForInput(state.targetThickness, unit);
            }
            els.unitOverrideThickness.innerText = unit;
            els.unitTargetThickness.innerText = unit;
            populateThicknessDropdown(els.selectOverrideThickness, state.confirmedThickness, unit);
            populateThicknessDropdown(els.selectTargetThickness, state.targetThickness, unit);
        }

        // Builds a preset dropdown's <option> list for the given current mm value / unit mode.
        function populateThicknessDropdown(select, currentMm, unit) {
            select.innerHTML = '';

            const matched = THICKNESS_PRESETS.some(p => Math.abs(p.mm - currentMm) < 1e-3);
            if (!matched) {
                const opt = document.createElement('option');
                opt.value = currentMm.toString();
                const label = formatThicknessForInput(currentMm, unit);
                opt.textContent = unit === 'in' ? `${label}" (custom)` : `${label} mm (custom)`;
                select.appendChild(opt);
            }

            THICKNESS_PRESETS.forEach(p => {
                const opt = document.createElement('option');
                opt.value = p.mm.toString();
                opt.textContent = (unit === 'in') ? p.labelIn : p.labelMm;
                select.appendChild(opt);
            });

            for (const opt of select.options) {
                if (opt.value && Math.abs(parseFloat(opt.value) - currentMm) < 1e-3) {
                    select.value = opt.value;
                    break;
                }
            }
        }

        // Restricts a text input to numeric entry: digits, at most one decimal separator
        // (accepts , or . and normalizes to .), and at most 3 digits after it (item 2 & 3).
        // Applied on 'input' so it can't block deletion — it only cleans up what remains.
        function sanitizeNumericInput(inputEl) {
            const cursorFromEnd = inputEl.value.length - (inputEl.selectionStart ?? inputEl.value.length);
            let v = inputEl.value.replace(',', '.');
            v = v.replace(/[^0-9.]/g, '');
            const firstDot = v.indexOf('.');
            if (firstDot !== -1) {
                v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replace(/\./g, '');
            }
            const dotIdx = v.indexOf('.');
            if (dotIdx !== -1 && v.length - dotIdx - 1 > 3) {
                v = v.slice(0, dotIdx + 4);
            }
            if (v !== inputEl.value) {
                inputEl.value = v;
                const pos = Math.max(0, v.length - cursorFromEnd);
                inputEl.setSelectionRange(pos, pos);
            }
            return v;
        }

        // ==========================================
        // Live Scale Recalculation Handlers
        // ==========================================
        function updateThicknessOverride() {
            const unit = state.displayUnit;
            const raw = sanitizeNumericInput(els.inputOverrideThickness);
            const inputVal = parseFloat(raw);
            // Allow the field to sit empty or mid-edit (e.g. "1.") without snapping back —
            // only recompute once there's a real positive number (fixes "can't delete digits").
            if (raw === '' || raw === '.' || isNaN(inputVal) || inputVal <= 0) return;

            state.confirmedThickness = (unit === 'in') ? inputVal * MM_PER_INCH : inputVal;
            if (state.confirmedThickness > 0) {
                state.scaleX = state.targetThickness / state.confirmedThickness;
                state.scaleY = state.scaleX;
                state.scalePercent = state.scaleX * 100;
                state.newWidth = state.originalWidth * state.scaleX;
                state.newHeight = state.originalHeight * state.scaleY;
            }
            syncUIValues();
            resizeCanvases();
        }

        function updateTargetThickness() {
            const unit = state.displayUnit;
            const raw = sanitizeNumericInput(els.inputTargetThickness);
            const inputVal = parseFloat(raw);
            if (raw === '' || raw === '.' || isNaN(inputVal) || inputVal <= 0) return;

            state.targetThickness = (unit === 'in') ? inputVal * MM_PER_INCH : inputVal;
            if (state.confirmedThickness > 0) {
                state.scaleX = state.targetThickness / state.confirmedThickness;
                state.scaleY = state.scaleX;
                state.scalePercent = state.scaleX * 100;
                state.newWidth = state.originalWidth * state.scaleX;
                state.newHeight = state.originalHeight * state.scaleY;
            }
            syncUIValues();
            resizeCanvases();
        }

        // Preset dropdown selection handlers (item 5)
        function handleOverrideThicknessPreset() {
            const val = parseFloat(els.selectOverrideThickness.value);
            if (isNaN(val)) return;
            // Store the preset's exact mm value directly — don't round-trip it through the
            // (unit-converted, decimal-rounded) display field, which would introduce precision
            // loss for presets whose inch label is an approximation (e.g. 4mm shown as "0.157").
            state.confirmedThickness = val;
            if (state.confirmedThickness > 0) {
                state.scaleX = state.targetThickness / state.confirmedThickness;
                state.scaleY = state.scaleX;
                state.scalePercent = state.scaleX * 100;
                state.newWidth = state.originalWidth * state.scaleX;
                state.newHeight = state.originalHeight * state.scaleY;
            }
            syncUIValues();
            resizeCanvases();
        }

        function handleTargetThicknessPreset() {
            const val = parseFloat(els.selectTargetThickness.value);
            if (isNaN(val)) return;
            state.targetThickness = val;
            if (state.confirmedThickness > 0) {
                state.scaleX = state.targetThickness / state.confirmedThickness;
                state.scaleY = state.scaleX;
                state.scalePercent = state.scaleX * 100;
                state.newWidth = state.originalWidth * state.scaleX;
                state.newHeight = state.originalHeight * state.scaleY;
            }
            syncUIValues();
            resizeCanvases();
        }

        // ==========================================
        // Exporter Files Generators
        // ==========================================
        function getUpscaledExportFilename() {
            const base = state.filename.replace(/\.(svg|dxf)$/i, '');
            const unit = state.displayUnit;
            const factor = (unit === 'in') ? 1 / MM_PER_INCH : 1.0;
            const targetVal = state.targetThickness * factor;
            let targetStr = targetVal.toFixed(3).replace(/0+$/, '').replace(/\.$/, '');
            targetStr = targetStr.replace('.', '_');
            return `vector-painter-scale-${targetStr}-${unit}-${base}.${state.fileType}`;
        }

        // ==========================================
        // Text-based scaling (preferred export path)
        // ==========================================
        // Rather than re-serializing geometry from the parsed shape model (which requires
        // perfectly reconstructing colors, stroke widths, subpath structure, and coordinate
        // orientation — and any small gap in that reconstruction becomes a visible bug), this
        // rewrites the ORIGINAL file's own text in place: every numeric X/Y coordinate inside a
        // geometry attribute gets multiplied by the scale factor, and nothing else in the file is
        // touched. Colors, classes, CSS, comments, structure, and formatting all pass through
        // byte-for-byte except for the numbers themselves.
        function scaleNumberList(str, scaleX, scaleY, startsWithX = true) {
            // Alternates X,Y,X,Y... across the numbers found in the string (matches how SVG
            // path/points data and DXF coordinate pairs are laid out).
            let i = 0;
            return str.replace(/-?\d*\.?\d+(?:[eE][-+]?\d+)?/g, (match) => {
                const isX = startsWithX ? (i % 2 === 0) : (i % 2 === 1);
                i++;
                const scale = isX ? scaleX : scaleY;
                return String(parseFloat(match) * scale);
            });
        }

        function removeSvgEditorLocks(svgText) {
            // Inkscape stores an object/layer lock as sodipodi:insensitive. Remove the attribute
            // regardless of its value: older Inkscape versions can interpret even "false" as
            // locked. Also remove equivalent vendor/data lock flags while preserving layer names,
            // groups, colors, paths and all ordinary SVG attributes.
            return svgText.replace(
                /\s+(?:(?:sodipodi|inkscape):insensitive|(?:[A-Za-z_][\w.-]*:)?lock(?:ed)?|data-lock(?:ed)?)\s*=\s*(?:"[^"]*"|'[^']*')/gi,
                ''
            );
        }

        function scaleTextSVG(svgText, scaleX, scaleY) {
            let out = svgText;

            // <path d="M x y C x1 y1, x2 y2, x y ...">, <polygon points="x,y x,y ...">,
            // <polyline points="...">  — all alternate X,Y within one attribute value.
            // Attribute values may have whitespace around '=' (seen in some CorelDRAW exports,
            // e.g. y2= "16010.76") — \s* tolerates that instead of silently skipping the match.
            out = out.replace(/\b(d|points)\s*=\s*"([^"]*)"/g, (full, attr, value) => {
                return `${attr}="${scaleNumberList(value, scaleX, scaleY, true)}"`;
            });

            // <line x1="" y1="" x2="" y2="">
            out = out.replace(/\bx1\s*=\s*"([^"]*)"/g, (m, v) => `x1="${parseFloat(v) * scaleX}"`);
            out = out.replace(/\by1\s*=\s*"([^"]*)"/g, (m, v) => `y1="${parseFloat(v) * scaleY}"`);
            out = out.replace(/\bx2\s*=\s*"([^"]*)"/g, (m, v) => `x2="${parseFloat(v) * scaleX}"`);
            out = out.replace(/\by2\s*=\s*"([^"]*)"/g, (m, v) => `y2="${parseFloat(v) * scaleY}"`);

            // <circle cx cy r>, <ellipse cx cy rx ry>
            out = out.replace(/\bcx\s*=\s*"([^"]*)"/g, (m, v) => `cx="${parseFloat(v) * scaleX}"`);
            out = out.replace(/\bcy\s*=\s*"([^"]*)"/g, (m, v) => `cy="${parseFloat(v) * scaleY}"`);
            out = out.replace(/\brx\s*=\s*"([^"]*)"/g, (m, v) => `rx="${parseFloat(v) * scaleX}"`);
            out = out.replace(/\bry\s*=\s*"([^"]*)"/g, (m, v) => `ry="${parseFloat(v) * scaleY}"`);
            // A plain <circle r="..."> has one radius — use the geometric mean of X/Y scale so it
            // stays a circle under non-uniform scaling instead of silently going elliptical.
            const rScale = Math.sqrt(Math.abs(scaleX * scaleY)) || 1;
            out = out.replace(/(<circle\b[^>]*\br)\s*=\s*"([^"]*)"/g, (full, prefix, v) => `${prefix}="${parseFloat(v) * rScale}"`);

            // <rect x y width height>
            out = out.replace(/(<rect\b[^>]*\bx)\s*=\s*"([^"]*)"/g, (full, prefix, v) => `${prefix}="${parseFloat(v) * scaleX}"`);
            out = out.replace(/(<rect\b[^>]*\by)\s*=\s*"([^"]*)"/g, (full, prefix, v) => `${prefix}="${parseFloat(v) * scaleY}"`);
            out = out.replace(/(<rect\b[^>]*\bwidth)\s*=\s*"([^"]*)"/g, (full, prefix, v) => `${prefix}="${parseFloat(v) * scaleX}"`);
            out = out.replace(/(<rect\b[^>]*\bheight)\s*=\s*"([^"]*)"/g, (full, prefix, v) => `${prefix}="${parseFloat(v) * scaleY}"`);

            // Root <svg> element's own width/height/viewBox
            out = out.replace(/(<svg\b[^>]*\bwidth)\s*=\s*"([\d.]+)(\w*)"/, (full, prefix, v, unit) => `${prefix}="${parseFloat(v) * scaleX}${unit}"`);
            out = out.replace(/(<svg\b[^>]*\bheight)\s*=\s*"([\d.]+)(\w*)"/, (full, prefix, v, unit) => `${prefix}="${parseFloat(v) * scaleY}${unit}"`);
            out = out.replace(/(viewBox)\s*=\s*"([\d.\s-]+)"/, (full, attr, v) => {
                const nums = v.trim().split(/\s+/).map(Number);
                if (nums.length !== 4) return full;
                const [minX, minY, w, h] = nums;
                return `${attr}="${minX * scaleX} ${minY * scaleY} ${w * scaleX} ${h * scaleY}"`;
            });

            // Stroke widths defined via CSS classes in a <style> block (CorelDRAW-style exports),
            // e.g. ".str0 {stroke:#00C800;stroke-width:7.62;...}" — scale by the geometric mean so
            // line thickness grows proportionally with the geometry.
            out = out.replace(/(stroke-width\s*:\s*)([\d.]+)/g, (full, prefix, v) => `${prefix}${parseFloat(v) * rScale}`);
            // Inline stroke-width="" attributes (less common, but some exporters use them directly)
            out = out.replace(/(\bstroke-width)\s*=\s*"([\d.]+)"/g, (full, prefix, v) => `${prefix}="${parseFloat(v) * rScale}"`);

            // Never carry editor lock metadata into the downloaded file. The exported geometry
            // remains fully selectable and editable in Inkscape and other SVG editors.
            return removeSvgEditorLocks(out);
        }

        // DXF text-based scaler. Unlike SVG, a DXF's numbers can't be scaled by simple pattern
        // matching alone: coordinate values are tagged with a group code on the PRECEDING line
        // (10/20 = primary X/Y, 11/21 = secondary X/Y, 40 = radius — except on SPLINE, where 40 is
        // a knot vector value that must be left untouched). This needs a minimal walk that tracks
        // which entity type each pair belongs to, without building a full shape model.
        function scaleTextDXF(dxfText, scaleX, scaleY) {
            const newline = dxfText.includes('\r\n') ? '\r\n' : '\n';
            const lines = dxfText.split(newline);
            const rScale = Math.sqrt(Math.abs(scaleX * scaleY)) || 1;

            const GEOMETRY_ENTITIES = new Set([
                'LINE', 'LWPOLYLINE', 'POLYLINE', 'VERTEX', 'CIRCLE', 'ARC',
                'SPLINE', 'ELLIPSE', 'POINT', 'INSERT'
            ]);

            let currentEntityType = null;
            let i = 0;
            while (i < lines.length - 1) {
                const codeLine = lines[i].trim();
                const code = parseInt(codeLine, 10);
                if (isNaN(code)) { i++; continue; }
                const value = lines[i + 1];

                if (code === 0) {
                    const val = value.trim();
                    currentEntityType = GEOMETRY_ENTITIES.has(val) ? val : null;
                    i += 2;
                    continue;
                }

                if (currentEntityType) {
                    let axisScale = null;
                    if (code === 10 || code === 11 || code === 12 || code === 13 || code === 14) {
                        axisScale = scaleX;
                    } else if (code === 20 || code === 21 || code === 22 || code === 23 || code === 24) {
                        axisScale = scaleY;
                    } else if (code === 40) {
                        // 40 means radius on CIRCLE/ARC/LWPOLYLINE (scale it), but a spline knot
                        // vector value on SPLINE (must NOT be scaled — knots are parametric, not
                        // spatial). Leave every other entity's code 40 untouched too, since it can
                        // mean unrelated things (e.g. linetype scale) we can't safely assume about.
                        if (currentEntityType === 'CIRCLE' || currentEntityType === 'ARC' || currentEntityType === 'LWPOLYLINE') {
                            axisScale = rScale;
                        }
                    }
                    if (axisScale !== null) {
                        const num = parseFloat(value);
                        if (!isNaN(num)) {
                            lines[i + 1] = String(num * axisScale);
                        }
                    }
                }
                i += 2;
            }

            return lines.join(newline);
        }

        function triggerDownload() {
            if (state.shapes.length === 0 || !state.originalText) return;

            const format = state.fileType;
            const filename = getUpscaledExportFilename();

            // Scale the ORIGINAL file's own text in place — this can't introduce color loss,
            // mirroring, or extra points, because geometry is never reconstructed, only the
            // numbers already in the file get multiplied. Export format always matches the
            // source format (conversion between SVG and DXF is not supported).
            let content, mime;
            if (format === 'svg') {
                content = scaleTextSVG(state.originalText, state.scaleX, state.scaleY);
                mime = 'image/svg+xml';
            } else {
                content = scaleTextDXF(state.originalText, state.scaleX, state.scaleY);
                mime = 'application/dxf';
            }

            const blob = new Blob([content], { type: mime });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            appRoot.appendChild(a);
            a.click();
            appRoot.removeChild(a);
            URL.revokeObjectURL(url);

            showToast('Download Complete', `Downloaded: ${filename}`, 'success');
        }

        // ==========================================
        // Toast Notification System
        // ==========================================
        function showToast(title, message, type = 'success') {
            let container = getById('vp-lcfr-toast-container');
            if (!container) {
                container = document.createElement('div');
                container.id = 'vp-lcfr-toast-container';
                container.style.position = 'fixed';
                container.style.bottom = '20px';
                container.style.right = '20px';
                container.style.zIndex = '9999';
                container.style.display = 'flex';
                container.style.flexDirection = 'column';
                container.style.gap = '10px';
                appRoot.appendChild(container);
            }

            const toast = document.createElement('div');
            toast.style.background = 'rgba(27, 32, 48, 0.95)';
            toast.style.backdropFilter = 'blur(8px)';
            toast.style.borderLeft = `4px solid ${type === 'success' ? 'var(--accent-cyan)' : type === 'warning' ? '#f59e0b' : '#ef4444'}`;
            toast.style.borderTop = '1px solid var(--panel-border)';
            toast.style.borderRight = '1px solid var(--panel-border)';
            toast.style.borderBottom = '1px solid var(--panel-border)';
            toast.style.padding = '12px 18px';
            toast.style.borderRadius = '8px';
            toast.style.boxShadow = '0 10px 25px rgba(0,0,0,0.4)';
            toast.style.color = '#fff';
            toast.style.fontFamily = 'var(--font-main)';
            toast.style.fontSize = '13px';
            toast.style.minWidth = '280px';
            toast.style.maxWidth = '360px';
            toast.style.transform = 'translateX(120%)';
            toast.style.transition = 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)';
            toast.style.display = 'flex';
            toast.style.alignItems = 'center';
            toast.style.gap = '12px';

            let icon = 'fa-circle-check';
            let iconColor = 'var(--accent-cyan)';
            if (type === 'warning') {
                icon = 'fa-triangle-exclamation';
                iconColor = '#f59e0b';
            } else if (type === 'error') {
                icon = 'fa-circle-xmark';
                iconColor = '#ef4444';
            }

            // Use textContent for messages because an imported filename or parser error can
            // contain user-controlled characters that must never be interpreted as HTML.
            const iconElement = document.createElement('i');
            iconElement.className = `fa-solid ${icon}`;
            iconElement.style.color = iconColor;
            iconElement.style.fontSize = '18px';

            const copy = document.createElement('div');
            const heading = document.createElement('strong');
            heading.style.display = 'block';
            heading.style.fontSize = '13px';
            heading.style.marginBottom = '2px';
            heading.textContent = title;

            const body = document.createElement('span');
            body.style.color = 'var(--text-secondary)';
            body.style.fontSize = '11px';
            body.textContent = message;

            copy.append(heading, body);
            toast.append(iconElement, copy);

            container.appendChild(toast);
            setTimeout(() => {
                toast.style.transform = 'translateX(0)';
            }, 50);

            setTimeout(() => {
                toast.style.transform = 'translateX(120%)';
                setTimeout(() => {
                    toast.remove();
                }, 300);
            }, 4000);
        }

        // ==========================================
        // Event Bindings
        // ==========================================
        function resizeCanvases() {
            requestAnimationFrame(() => {
                const dpr = window.devicePixelRatio || 1;

                function setCanvasSize(canvas, cssWidth, cssHeight) {
                    canvas.style.width = cssWidth + 'px';
                    canvas.style.height = cssHeight + 'px';
                    canvas.width = Math.round(cssWidth * dpr);
                    canvas.height = Math.round(cssHeight * dpr);
                    const ctx = canvas.getContext('2d');
                    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
                }

                if (state.shapes.length === 0) {
                    const container1 = els.canvasOriginal.parentElement;
                    setCanvasSize(els.canvasOriginal, container1.clientWidth, container1.clientHeight);

                    const container2 = els.canvasScaled.parentElement;
                    setCanvasSize(els.canvasScaled, container2.clientWidth, container2.clientHeight);

                    drawBoth();
                    return;
                }

                const container1 = els.canvasOriginal.parentElement;
                const container2 = els.canvasScaled.parentElement;

                const availW = container1.clientWidth || 300;
                const availH = container1.clientHeight || 300;

                const bboxOrig = getViewportBoundingBox(state.shapes);
                const bboxScaled = {
                    width: bboxOrig.width * state.scaleX,
                    height: bboxOrig.height * state.scaleY
                };

                // Scale padding down for small containers (extreme browser zoom can shrink the
                // container to a fraction of its normal size) so the ruler/margin never eats a
                // disproportionate share of the available space. Floors keep it usable at very
                // small sizes; caps keep it from growing past the original fixed values.
                const paddingScale = Math.max(0.4, Math.min(1, Math.min(availW, availH) / 400));
                const padLeft = Math.max(18, 42 * paddingScale);
                const padRight = Math.max(6, 14 * paddingScale);
                const padTop = Math.max(6, 14 * paddingScale);
                const padBottom = Math.max(18, 42 * paddingScale);

                const usableW = availW - padLeft - padRight;
                const usableH = availH - padTop - padBottom;

                const pxPerMmOrig = Math.min(usableW / bboxOrig.width, usableH / bboxOrig.height);
                const pxPerMmScaled = Math.min(usableW / bboxScaled.width, usableH / bboxScaled.height);

                // Use the smaller scale factor so the larger drawing fits the card perfectly
                const pxPerMm = (state.scaleX >= 1.0) ? pxPerMmScaled : pxPerMmOrig;

                setCanvasSize(els.canvasOriginal, bboxOrig.width * pxPerMm + padLeft + padRight, bboxOrig.height * pxPerMm + padTop + padBottom);
                setCanvasSize(els.canvasScaled, bboxScaled.width * pxPerMm + padLeft + padRight, bboxScaled.height * pxPerMm + padTop + padBottom);

                state.currentPxPerMm = pxPerMm;
                state.currentPadLeft = padLeft;
                state.currentPadTop = padTop;

                drawBoth();
            });
        }

        // A deferred Shopify asset normally runs before the load event, but the theme editor can
        // inject a section after that event has already fired. Initialize correctly in both cases.
        if (document.readyState === 'complete') {
            resizeCanvases();
        } else {
            window.addEventListener('load', resizeCanvases, { once: true });
        }

        window.addEventListener('resize', resizeCanvases);

        // On mobile, keep the natural document order:
        // Upload -> Display Units -> File Analysis -> Material Thickness -> Download ->
        // About & Instructions -> Original File -> Rescaled File.
        // Before import, CSS hides Display Units and both preview cards.

        // Browser page zoom (Ctrl+/Cmd+ +/-, or pinch-zoom on some browsers) changes
        // devicePixelRatio directly. The plain 'resize' event doesn't reliably fire for this on
        // every browser, so re-attach a matchMedia listener tied to the current dpr each time it
        // changes — this is the standard technique for reacting to zoom-driven dpr changes.
        function watchDevicePixelRatio() {
            const mq = window.matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
            mq.addEventListener('change', () => {
                resizeCanvases();
                watchDevicePixelRatio(); // dpr changed, so the old query no longer matches future changes
            }, { once: true });
        }
        watchDevicePixelRatio();

        appRoot.addEventListener('dragover', e => {
            e.preventDefault();
            els.dropZone.style.borderColor = 'var(--accent-cyan)';
            els.dropZone.style.background = 'rgba(120, 211, 255, 0.05)';
        });

        appRoot.addEventListener('dragleave', e => {
            e.preventDefault();
            els.dropZone.style.borderColor = 'var(--panel-border)';
            els.dropZone.style.background = 'rgba(16, 21, 32, 0.3)';
        });

        appRoot.addEventListener('drop', e => {
            e.preventDefault();
            els.dropZone.style.borderColor = 'var(--panel-border)';
            els.dropZone.style.background = 'rgba(16, 21, 32, 0.3)';
            if (e.dataTransfer.files.length > 0) {
                loadFile(e.dataTransfer.files[0]);
            }
        });

        els.dropZone.addEventListener('click', () => {
            els.fileInput.click();
        });

        els.dropZone.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                els.fileInput.click();
            }
        });

        els.fileInput.addEventListener('change', e => {
            if (e.target.files.length > 0) {
                loadFile(e.target.files[0]);
            }
        });

        els.unitControl.querySelectorAll('.segment-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                els.unitControl.querySelector('.segment-btn.active').classList.remove('active');
                els.unitControl.querySelectorAll('.segment-btn').forEach(option => {
                    option.setAttribute('aria-pressed', String(option === btn));
                });
                btn.classList.add('active');
                
                state.displayUnit = btn.dataset.unit;
                syncUIValues();
                drawBoth();
            });
        });

        els.inputOverrideThickness.addEventListener('input', updateThicknessOverride);
        els.inputTargetThickness.addEventListener('input', updateTargetThickness);
        els.selectOverrideThickness.addEventListener('change', handleOverrideThicknessPreset);
        els.selectTargetThickness.addEventListener('change', handleTargetThicknessPreset);

        els.btnExport.addEventListener('click', () => triggerDownload());

        function openAboutModal() {
            els.aboutModal.classList.add('active');
            els.aboutModal.setAttribute('aria-hidden', 'false');
            els.btnCloseAbout.focus();
        }

        function closeAboutModal() {
            els.aboutModal.classList.remove('active');
            els.aboutModal.setAttribute('aria-hidden', 'true');
            els.btnAbout.focus();
        }

        els.btnAbout.addEventListener('click', openAboutModal);
        els.btnCloseAbout.addEventListener('click', closeAboutModal);
        els.aboutModal.addEventListener('click', e => {
            if (e.target === els.aboutModal) {
                closeAboutModal();
            }
        });
        document.addEventListener('keydown', e => {
            if (e.key === 'Escape' && els.aboutModal.classList.contains('active')) {
                closeAboutModal();
            }
        });
})();
